/* ============================================================
   Size Guide + Framing & Paper Guide modals.

   Ported from the Claude Design handoff (claude.ai/design). The editorial
   copy, specifications and sample imagery live in the DATA block below —
   this is a first pass meant to be tweaked. Sizes/finishes map onto the
   product's native Size / Frame <select>s, so the footer CTAs ("Choose …",
   "Apply this framing") drive the same proxy layer as framing-options.js.

   Triggers: [data-fo-size-guide] opens the Size Guide,
             [data-fo-framing-guide] opens the Framing & Paper Guide.
   Imagery can be overridden from Liquid via window.foGuideAssets =
   { title, print, rooms:[...] }.
   ============================================================ */
(function () {
  'use strict';

  /* ------------------------------ DATA ------------------------------ */
  var A = window.foGuideAssets || {};
  var TITLE = A.title || 'Your print';
  var PRINT = A.print || '';
  var ROOMS = (A.rooms && A.rooms.length) ? A.rooms : [];
  function room(i) { return ROOMS.length ? ROOMS[i % ROOMS.length] : PRINT; }

  var SW_NAT = 'linear-gradient(135deg,#d8b27e,#b98a52)';
  var SW_WHT = '#f3f1ec';
  var SW_BLK = '#1c1b18';

  // ---- Sizes ----------------------------------------------------------
  // wCm/hCm are the UNFRAMED print dimensions in PORTRAIT orientation and
  // drive the to-scale diagram. For 'horizontal' the width/height (and the
  // framed strings) are swapped automatically. Classic/Box dims that read
  // 'Not available' / 'TBC' are passed through verbatim. Tweak freely.
  var NA = 'Not available', TBC = 'To be confirmed';

  // Rectangular sizes — shared by Vertical & Horizontal (A-series + large inch).
  var RECT_SIZES = [
    { name: 'Mini', code: 'A4', wCm: 21, hCm: 29.7, unframedIn: '8.3 × 11.7 in',
      classicCm: '24 × 33 × 2 cm', classicIn: '9.4 × 13 × 0.8 in', boxCm: '24 × 33 × 3 cm', boxIn: '9.4 × 13 × 1.2 in' },
    { name: 'Small', code: 'A3', wCm: 29.7, hCm: 42, unframedIn: '11.7 × 16.5 in',
      classicCm: '33 × 45.4 × 2 cm', classicIn: '13 × 17.9 × 0.8 in', boxCm: '33 × 45.4 × 3 cm', boxIn: '13 × 17.9 × 1.2 in' },
    { name: 'Medium', code: 'A2', wCm: 42, hCm: 59.4, unframedIn: '16.5 × 23.4 in',
      classicCm: '45 × 62.4 × 2 cm', classicIn: '17.7 × 24.6 × 0.8 in', boxCm: '46 × 63.5 × 4.5 cm', boxIn: '18.1 × 25 × 1.8 in' },
    { name: 'Large', code: 'A1', wCm: 59.4, hCm: 84.1, unframedIn: '23.4 × 33.1 in',
      classicCm: '62.4 × 87.1 × 2 cm', classicIn: '24.6 × 34.3 × 0.8 in', boxCm: '63.5 × 88 × 4.5 cm', boxIn: '25 × 34.6 × 1.8 in' },
    { name: 'X-Large', code: 'B1', wCm: 70.7, hCm: 100, unframedIn: '27.8 × 39.4 in',
      classicCm: '73.7 × 103 × 2 cm', classicIn: '29 × 40.6 × 0.8 in', boxCm: '75 × 105 × 4.5 cm', boxIn: '29.5 × 41.3 × 1.8 in' },
    { name: 'Gallery', code: 'A0', wCm: 84.1, hCm: 118.9, unframedIn: '33.1 × 46.8 in',
      classicCm: '87.2 × 122.1 × 3 cm', classicIn: '34.3 × 48.1 × 1.2 in', boxCm: '89 × 124 × 4.5 cm', boxIn: '35 × 48.8 × 1.8 in' },
    { name: 'Giant', code: '40x60"', wCm: 101.6, hCm: 152.4, unframedIn: '40 × 60 in',
      classicCm: NA, classicIn: NA, boxCm: '106 × 157 × 4.5 cm', boxIn: '41.7 × 61.8 × 1.8 in' },
    { name: 'Epic', code: '50x75"', wCm: 127, hCm: 190.5, unframedIn: '50 × 75 in',
      classicCm: NA, classicIn: NA, boxCm: TBC, boxIn: TBC },
    { name: 'Statement', code: '60x90"', wCm: 152.4, hCm: 228.6, unframedIn: '60 × 90 in',
      classicCm: NA, classicIn: NA, boxCm: TBC, boxIn: TBC }
  ];

  // Square sizes — own range.
  var SQUARE_SIZES = [
    { name: 'Mini', code: '12x12"', wCm: 30.5, hCm: 30.5, unframedIn: '12 × 12 in',
      classicCm: '33.5 × 33.5 × 2 cm', classicIn: '13.2 × 13.2 × 0.8 in', boxCm: '33.5 × 33.5 × 3 cm', boxIn: '13.2 × 13.2 × 1.2 in' },
    { name: 'Medium', code: '20x20"', wCm: 50.8, hCm: 50.8, unframedIn: '20 × 20 in',
      classicCm: '54 × 54 × 2 cm', classicIn: '21.3 × 21.3 × 0.8 in', boxCm: '58 × 58 × 4.5 cm', boxIn: '22.8 × 22.8 × 1.8 in' },
    { name: 'Large', code: '28x28"', wCm: 71.1, hCm: 71.1, unframedIn: '28 × 28 in',
      classicCm: '74 × 74 × 2 cm', classicIn: '29.1 × 29.1 × 0.8 in', boxCm: '78 × 78 × 4.5 cm', boxIn: '30.7 × 30.7 × 1.8 in' },
    { name: 'X-Large', code: '36x36"', wCm: 91.4, hCm: 91.4, unframedIn: '36 × 36 in',
      classicCm: '94.5 × 94.5 × 3 cm', classicIn: '37.2 × 37.2 × 1.2 in', boxCm: '96 × 96 × 3 cm', boxIn: '37.8 × 37.8 × 1.2 in' },
    { name: 'Epic', code: '45x45"', wCm: 114.3, hCm: 114.3, unframedIn: '45 × 45 in',
      classicCm: NA, classicIn: NA, boxCm: '118 × 118 × 4.5 cm', boxIn: '46.5 × 46.5 × 1.8 in' }
  ];

  var ORIENTATIONS = [
    { id: 'vertical', label: 'Vertical' },
    { id: 'horizontal', label: 'Horizontal' },
    { id: 'square', label: 'Square' }
  ];

  function sizesFor(orient) { return orient === 'square' ? SQUARE_SIZES : RECT_SIZES; }
  function fmtNum(n) { return (Math.round(n * 10) / 10).toString(); }
  function swapDims(s) {
    if (!s || /not available|tbc|to be confirmed/i.test(s)) return s;
    var m = s.match(/^\s*([\d.]+)\s*[×x]\s*([\d.]+)(.*)$/i);
    return m ? (m[2] + ' × ' + m[1] + m[3]) : s;
  }
  // Present a size for an orientation (handles portrait↔landscape swap).
  function present(size, orient) {
    var w = size.wCm, h = size.hCm, horiz = orient === 'horizontal';
    if (horiz) { var t = w; w = h; h = t; }
    var sw = horiz ? swapDims : function (x) { return x; };
    return {
      name: size.name, code: size.code, wCm: w, hCm: h,
      dim: fmtNum(w) + ' × ' + fmtNum(h) + ' cm',
      dimIn: sw(size.unframedIn),
      classicCm: sw(size.classicCm), classicIn: sw(size.classicIn),
      boxCm: sw(size.boxCm), boxIn: sw(size.boxIn)
    };
  }

  var PROFILES = [
    { id: 'classic', label: 'Classic', sub: 'Slim gallery profile', priceNote: '',
      faceMm: 20, depthMm: 20, face: '2 cm', depth: '2 cm', glazing: 'Anti-glare acrylic',
      mount: 'Flush behind acrylic, on acid-free foamboard', material: 'Solid wood', float: false,
      desc: 'A refined, low-profile moulding that sits close to the wall. The print is mounted on acid-free foamboard and held flush behind acrylic glazing — quiet, classic and timeless.' },
    { id: 'shadow', label: 'Premium Shadow Box', sub: 'Deep float-mounted box', priceNote: '',
      faceMm: 30, depthMm: 45, face: '3 cm', depth: '4.5 cm', glazing: 'Acrylic, with spacer',
      mount: 'Floated on a spacer set behind the acrylic', material: 'Solid wood', float: true,
      desc: 'The print sits on a spacer set back from the acrylic, casting a soft shadow line around the paper — a contemporary, collector-grade presentation. Depth and face vary with size.' }
  ];

  // Size-dependent framing specs (match the uploaded guide).
  function shadowDims(sizeName) {
    var small = ['mini', 'small'];
    return small.indexOf(String(sizeName).toLowerCase()) >= 0
      ? { face: '2 cm', depth: '3 cm', faceMm: 20, depthMm: 30 }
      : { face: '3 cm', depth: '4.5 cm', faceMm: 30, depthMm: 45 };
  }
  function hangingHardware(sizeName) {
    var big = ['giant', 'epic', 'statement'];
    return big.indexOf(String(sizeName).toLowerCase()) >= 0 ? 'Two-hole D-rings' : 'D-rings & wire';
  }
  function acrylicThickness(sizeName) {
    var thick = ['giant', 'epic', 'statement'];
    return thick.indexOf(String(sizeName).toLowerCase()) >= 0 ? '3 mm' : '2 mm';
  }
  var FINISHES = [
    { id: 'natural', label: 'Natural Oak', swatch: SW_NAT, grain: true, desc: 'Warm, lightly grained oak with a matte oiled finish.' },
    { id: 'white', label: 'Satin White', swatch: SW_WHT, grain: false, desc: 'Clean contemporary white with a soft satin sheen.' },
    { id: 'black', label: 'Matte Black', swatch: SW_BLK, grain: false, desc: 'Deep, even matte black that frames bold imagery.' }
  ];
  var PAPERS = [
    { id: 'cotton', label: 'Smooth Fine Art', tag: 'Ilford', tone: '#f4efe6', brand: 'Ilford',
      weight: '200 gsm', thick: '0.30 mm', finish: 'Matte · smooth', base: 'Acid-free fine art',
      white: 'Natural white', oba: 'OBA-free', longevity: '100+ yrs',
      desc: 'A smooth, acid-free Ilford fine-art stock with a matte surface and gentle warmth. Renders soft tonal transitions beautifully and is built to last.' }
  ];

  var ICON = {
    ruler: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="2.5" y="8" width="19" height="8" rx="1"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>',
    frame: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="3" width="18" height="18" rx="1"/><rect x="7.5" y="7.5" width="9" height="9" rx="0.5"/></svg>',
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    arrowL: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 6l-6 6 6 6"/></svg>',
    arrowR: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="transform:rotate(180deg)"><path d="M15 6l-6 6 6 6"/></svg>'
  };

  /* ----------------------------- helpers ---------------------------- */
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function elFrom(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }

  function frameSelectEl() { return document.querySelector('select[data-select-name="Frame"], .product-form__option.Frame select'); }
  function sizeSelectEl() { return document.querySelector('select[data-select-name="Size"], .product-form__option.Size select'); }
  function optText(o) { return (o.textContent || o.value || '').trim().toLowerCase(); }

  // Normalise size codes/option text for matching (A4, 40x60", 12x12" …).
  function normCode(s) { return String(s).toLowerCase().replace(/×/g, 'x').replace(/["\s]/g, ''); }

  function applySize(s) {
    var sel = sizeSelectEl();
    if (!sel) return;
    var code = normCode(s.code);
    var opt = [].slice.call(sel.options).filter(function (o) {
      return normCode(optText(o)).indexOf(code) >= 0;
    })[0];
    // fall back to name prefix if the code isn't found in the option text
    if (!opt) {
      var name = s.name.toLowerCase();
      opt = [].slice.call(sel.options).filter(function (o) {
        var t = optText(o);
        return t.indexOf(name) === 0 || t.split(/[^a-z]+/i)[0] === name;
      })[0];
    }
    if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function applyFraming(finId, profId) {
    var sel = frameSelectEl();
    if (!sel) return;
    var color = finId; // natural / white / black
    var target = profId === 'shadow' ? color + ' box' : color;
    var opts = [].slice.call(sel.options);
    var opt = opts.filter(function (o) { return optText(o) === target; })[0];
    if (!opt) {
      opt = opts.filter(function (o) {
        var t = optText(o);
        var hasBox = t.indexOf('box') >= 0;
        return t.indexOf(color) >= 0 && (profId === 'shadow' ? hasBox : !hasBox);
      })[0];
    }
    if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  // Returns the current { orient, code } from the native Size select + the
  // injected orientation, defaulting sensibly when nothing matches.
  function readCurrentSize() {
    var injected = (A.orientation || '').toLowerCase();
    var orient = injected === 'horizontal' || injected === 'square' ? injected : 'vertical';
    var sel = sizeSelectEl();
    var t = sel ? normCode(optText(sel.options[sel.selectedIndex] || { value: sel.value })) : '';
    // square codes win regardless of injected orientation
    var sq = SQUARE_SIZES.filter(function (s) { return t.indexOf(normCode(s.code)) >= 0; })[0];
    if (sq) return { orient: 'square', code: sq.code };
    var rect = RECT_SIZES.filter(function (s) { return t.indexOf(normCode(s.code)) >= 0; })[0];
    return { orient: orient === 'square' ? 'vertical' : orient, code: rect ? rect.code : sizesFor(orient)[0].code };
  }

  function readCurrentFraming() {
    var sel = frameSelectEl();
    var t = sel ? optText(sel.options[sel.selectedIndex] || { value: sel.value }) : '';
    var fin = t.indexOf('white') >= 0 ? 'white' : t.indexOf('black') >= 0 ? 'black' : 'natural';
    var prof = t.indexOf('box') >= 0 ? 'shadow' : 'classic';
    if (t.indexOf('print only') >= 0 || t === '') { fin = 'natural'; prof = 'classic'; }
    return { fin: fin, prof: prof };
  }

  /* --------------------------- SVG / macros -------------------------- */
  function scaleDiagram(s) {
    var PXCM = 1.18, FLOOR = 286, PERSON_CM = 170;
    var personPx = PERSON_CM * PXCM, personTop = FLOOR - personPx;
    var hPx = s.hCm * PXCM, wPx = s.wCm * PXCM;
    var printCY = FLOOR - 150 * PXCM, printTop = printCY - hPx / 2;
    var printX = 150, printRight = printX + wPx, pcx = 86, headR = 13;
    return '<svg viewBox="0 0 320 320" width="100%" height="100%" style="display:block" aria-label="Scale diagram for ' + esc(s.name) + '">'
      + '<rect x="0" y="0" width="320" height="320" fill="#faf8f3"/>'
      + '<line x1="20" y1="' + FLOOR + '" x2="300" y2="' + FLOOR + '" stroke="#d2cdc1" stroke-width="1.4"/>'
      + '<line x1="20" y1="' + (FLOOR + 0.5) + '" x2="300" y2="' + (FLOOR + 0.5) + '" stroke="#d2cdc1" stroke-width="1" stroke-dasharray="2 4" opacity="0.6"/>'
      + '<g fill="#cfc9bb"><circle cx="' + pcx + '" cy="' + (personTop + headR) + '" r="' + headR + '"/>'
      + '<path d="M' + (pcx - 15) + ' ' + (personTop + headR * 2 + 6) + ' q15 -10 30 0 l4 ' + (personPx * 0.42)
      + ' q-3 8 -9 8 l-6 0 l-2 ' + (personPx * 0.40) + ' q0 6 -6 6 q-6 0 -6 -6 l-1 -' + (personPx * 0.30)
      + ' l-1 ' + (personPx * 0.30) + ' q0 6 -6 6 q-6 0 -6 -6 l-2 -' + (personPx * 0.40) + ' l-6 0 q-6 0 -9 -8 z"/></g>'
      + '<text x="' + pcx + '" y="' + (FLOOR + 18) + '" text-anchor="middle" fill="#a39e95" font-size="10" letter-spacing="0.5">170 cm</text>'
      + '<rect x="' + printX + '" y="' + printTop + '" width="' + wPx + '" height="' + hPx + '" fill="#fff" stroke="#1c1b18" stroke-width="1.6"/>'
      + '<rect x="' + (printX + 5) + '" y="' + (printTop + 5) + '" width="' + (wPx - 10) + '" height="' + (hPx - 10) + '" fill="none" stroke="#e0dccf" stroke-width="1"/>'
      + '<g stroke="#9a7b3f" stroke-width="1"><line x1="' + printX + '" y1="' + (printTop - 12) + '" x2="' + printRight + '" y2="' + (printTop - 12) + '"/>'
      + '<line x1="' + printX + '" y1="' + (printTop - 16) + '" x2="' + printX + '" y2="' + (printTop - 8) + '"/>'
      + '<line x1="' + printRight + '" y1="' + (printTop - 16) + '" x2="' + printRight + '" y2="' + (printTop - 8) + '"/></g>'
      + '<text x="' + ((printX + printRight) / 2) + '" y="' + (printTop - 18) + '" text-anchor="middle" fill="#9a7b3f" font-size="11" font-weight="600">' + s.wCm + ' cm</text>'
      + '<g stroke="#9a7b3f" stroke-width="1"><line x1="' + (printRight + 12) + '" y1="' + printTop + '" x2="' + (printRight + 12) + '" y2="' + (printTop + hPx) + '"/>'
      + '<line x1="' + (printRight + 8) + '" y1="' + printTop + '" x2="' + (printRight + 16) + '" y2="' + printTop + '"/>'
      + '<line x1="' + (printRight + 8) + '" y1="' + (printTop + hPx) + '" x2="' + (printRight + 16) + '" y2="' + (printTop + hPx) + '"/></g>'
      + '<text x="' + (printRight + 18) + '" y="' + (printTop + hPx / 2) + '" fill="#9a7b3f" font-size="11" font-weight="600" transform="rotate(90 ' + (printRight + 18) + ' ' + (printTop + hPx / 2) + ')" text-anchor="middle">' + s.hCm + ' cm</text>'
      + '</svg>';
  }

  function frameCrossSection(profile, finish) {
    var col = finish ? finish.swatch : SW_NAT;
    var isGrad = typeof col === 'string' && col.indexOf('linear') === 0;
    var fill = isGrad ? '#cda25f' : col;
    var stroke = finish && finish.id === 'white' ? '#cfcabd' : 'rgba(0,0,0,.35)';
    var PPM = 4.0, yBack = 246, depthPx = profile.depthMm * PPM, yFront = yBack - depthPx;
    var x0 = 78, fw = profile.faceMm * 2.7, x1 = x0 + fw, lipOv = 20, lipT = 13, xEnd = 300;
    var moulding = x0 + ',' + yBack + ' ' + x0 + ',' + yFront + ' ' + (x1 + lipOv) + ',' + yFront + ' '
      + (x1 + lipOv) + ',' + (yFront + lipT) + ' ' + x1 + ',' + (yFront + lipT) + ' ' + x1 + ',' + yBack;
    var gTop = yFront + 2, gH = 5, layers;
    if (!profile.float) {
      var matH = depthPx * 0.34, prH = 6, matTop = gTop + gH, prTop = matTop + matH;
      layers = [
        { y: gTop, h: gH, fill: '#cfe0e6', op: 0.7 },
        { y: matTop, h: matH, fill: '#fbfaf6', op: 1 },
        { y: prTop, h: prH, fill: '#d8b27e', op: 1 },
        { y: prTop + prH, h: yBack - (prTop + prH), fill: '#2a2722', op: 1 }
      ];
    } else {
      var gapH = depthPx * 0.30, prH2 = 6, prTop2 = gTop + gH + gapH;
      layers = [
        { y: gTop, h: gH, fill: '#cfe0e6', op: 0.7 },
        { y: prTop2, h: prH2, fill: '#d8b27e', op: 1 },
        { y: yBack - 10, h: 10, fill: '#2a2722', op: 1 }
      ];
    }
    var s = '<svg viewBox="0 0 320 300" width="100%" height="100%" style="display:block;background:#faf8f3" aria-label="' + esc(profile.label) + ' cross-section">';
    s += '<line x1="' + (x0 - 40) + '" y1="' + yBack + '" x2="' + (xEnd + 6) + '" y2="' + yBack + '" stroke="#d2cdc1" stroke-width="1.4"/>';
    s += '<rect x="' + (xEnd - 2) + '" y="' + (yFront - 6) + '" width="6" height="' + (depthPx + 6) + '" fill="#ece7dc"/>';
    s += '<ellipse cx="' + (x0 + fw / 2 + 50) + '" cy="' + (yBack + 5) + '" rx="120" ry="5" fill="rgba(28,27,24,.06)"/>';
    layers.forEach(function (L) { s += '<rect x="' + x1 + '" y="' + L.y + '" width="' + (xEnd - x1) + '" height="' + L.h + '" fill="' + L.fill + '" opacity="' + L.op + '"/>'; });
    s += '<defs><linearGradient id="fgFadeDown" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="rgba(28,27,24,.16)"/><stop offset="1" stop-color="rgba(28,27,24,0)"/></linearGradient></defs>';
    if (profile.float) s += '<rect x="' + x1 + '" y="' + (yFront + 7) + '" width="' + (xEnd - x1) + '" height="' + (depthPx * 0.30) + '" fill="url(#fgFadeDown)"/>';
    s += '<polygon points="' + moulding + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.2"/>';
    if (finish && finish.grain) { for (var i = 0; i < 4; i++) { var yy = yFront + 8 + i * ((depthPx - 12) / 4); s += '<line x1="' + (x0 + 3) + '" y1="' + yy + '" x2="' + (x1 - 3) + '" y2="' + yy + '" stroke="rgba(120,80,30,.25)" stroke-width="1"/>'; } }
    s += '<g stroke="var(--gold)" stroke-width="1"><line x1="' + (x0 - 22) + '" y1="' + yFront + '" x2="' + (x0 - 22) + '" y2="' + yBack + '"/><line x1="' + (x0 - 26) + '" y1="' + yFront + '" x2="' + (x0 - 18) + '" y2="' + yFront + '"/><line x1="' + (x0 - 26) + '" y1="' + yBack + '" x2="' + (x0 - 18) + '" y2="' + yBack + '"/></g>';
    s += '<text x="' + (x0 - 28) + '" y="' + ((yFront + yBack) / 2) + '" fill="var(--gold)" font-weight="700" font-size="11" letter-spacing=".04em" text-anchor="middle" transform="rotate(-90 ' + (x0 - 28) + ' ' + ((yFront + yBack) / 2) + ')">' + esc(profile.depth) + ' depth</text>';
    s += '<g stroke="#a39e95" stroke-width="1"><line x1="' + x0 + '" y1="' + (yFront - 12) + '" x2="' + x1 + '" y2="' + (yFront - 12) + '"/><line x1="' + x0 + '" y1="' + (yFront - 15) + '" x2="' + x0 + '" y2="' + (yFront - 9) + '"/><line x1="' + x1 + '" y1="' + (yFront - 15) + '" x2="' + x1 + '" y2="' + (yFront - 9) + '"/></g>';
    s += '<text x="' + ((x0 + x1) / 2) + '" y="' + (yFront - 17) + '" fill="#75716a" font-size="9.5" letter-spacing=".04em" text-anchor="middle">' + esc(profile.face) + ' face</text>';
    s += '<text x="' + (xEnd - 4) + '" y="' + (yFront - 4) + '" fill="#a39e95" font-size="9.5" letter-spacing=".04em" text-anchor="end">' + (profile.float ? 'Float reveal' : 'Flush mat') + '</text>';
    s += '<text x="' + (x0 - 40) + '" y="' + (yBack + 14) + '" fill="#a39e95" font-size="9.5" letter-spacing=".04em">Wall</text>';
    return s + '</svg>';
  }

  function cornerMacro(finish, profile, border) {
    var frameBg = finish.grain ? 'linear-gradient(180deg,#dcb681,#c5945a)' : finish.swatch;
    var grain = finish.grain ? 'repeating-linear-gradient(180deg, rgba(120,80,30,.16) 0 1px, transparent 1px 7px)' : 'none';
    var frameTh = 46, matTh = border ? 30 : 8;
    var shadow = profile && profile.float ? '0 18px 40px rgba(28,27,24,.32)' : '0 10px 26px rgba(28,27,24,.22)';
    var matShadow = profile && profile.float ? 'inset 7px 7px 16px rgba(28,27,24,.20)' : 'inset 2px 2px 6px rgba(28,27,24,.12)';
    return '<div style="position:absolute;inset:0;overflow:hidden;background:#efece4">'
      + '<div style="position:absolute;top:15%;left:15%;width:135%;height:135%;background:' + frameBg + ';box-shadow:' + shadow + '">'
      + '<div style="position:absolute;inset:0;background-image:' + grain + ';pointer-events:none"></div>'
      + '<div style="position:absolute;top:' + frameTh + 'px;left:' + frameTh + 'px;width:100%;height:100%;background:#fbfaf6;box-shadow:' + matShadow + '">'
      + '<div style="position:absolute;top:' + matTh + 'px;left:' + matTh + 'px;width:100%;height:100%;background:url(' + PRINT + ') 0 0 / 360px 450px;box-shadow:inset 2px 2px 8px rgba(0,0,0,.12)"></div>'
      + '</div></div></div>';
  }

  function paperMacro(paper) {
    var fid = 'fg-pf-' + paper.id;
    return '<svg viewBox="0 0 320 320" width="100%" height="100%" style="display:block" aria-label="' + esc(paper.label) + ' texture">'
      + '<defs><filter id="' + fid + '"><feTurbulence type="fractalNoise" baseFrequency="' + (paper.id === 'textured' ? '0.5' : '0.85') + '" numOctaves="2" stitchTiles="stitch"/><feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 .9 0"/></filter>'
      + '<radialGradient id="fgPaperVig" cx="0.35" cy="0.3" r="0.9"><stop offset="0.55" stop-color="rgba(255,255,255,0)"/><stop offset="1" stop-color="rgba(120,110,90,.10)"/></radialGradient></defs>'
      + '<rect width="320" height="320" fill="' + paper.tone + '"/>'
      + '<rect width="320" height="320" filter="url(#' + fid + ')" opacity="' + (paper.id === 'textured' ? 0.10 : 0.055) + '"/>'
      + '<rect width="320" height="320" fill="url(#fgPaperVig)"/></svg>';
  }

  function paperEdge(paper) {
    return '<svg viewBox="0 0 320 320" width="100%" height="100%" style="display:block;background:#faf8f3" aria-label="' + esc(paper.label) + ' thickness">'
      + '<rect x="40" y="150" width="240" height="20" fill="' + paper.tone + '" stroke="#cfc8b8" stroke-width="1.2"/>'
      + '<rect x="40" y="150" width="240" height="5" fill="rgba(255,255,255,.6)"/>'
      + '<g stroke="var(--gold)" stroke-width="1"><line x1="296" y1="150" x2="296" y2="170"/><line x1="292" y1="150" x2="300" y2="150"/><line x1="292" y1="170" x2="300" y2="170"/></g>'
      + '<text x="160" y="135" text-anchor="middle" fill="#1c1b18" font-family="Cormorant Garamond" font-size="30" font-weight="500">' + esc(paper.weight) + '</text>'
      + '<text x="160" y="198" text-anchor="middle" fill="#75716a" font-size="11" letter-spacing=".06em">' + esc(paper.thick) + ' · ' + esc(paper.finish) + '</text></svg>';
  }

  function specRow(k, v, strong) {
    return '<div class="fg-spec-row"><span class="fg-spec-k">' + esc(k) + '</span><span class="fg-spec-v' + (strong ? ' fg-spec-v--strong' : '') + '">' + esc(v) + '</span></div>';
  }
  function panelBox(inner, label) {
    return '<div class="fg-panelbox">' + inner + '<span class="fg-panel-label">' + esc(label) + '</span></div>';
  }
  function photoInner(src, alt) { return '<img src="' + src + '" alt="' + esc(alt) + '">'; }

  /* ------ print-in-frame compositor (In-a-room / Styled photos) ------
     Per size+orientation, look up a photo (+ optional 4 frame corners and
     blend mode from the Frame Corner Tool) and warp the product's own print
     into the frame with a CSS matrix3d. Config lives in a JSON block on the
     page:  <script type="application/json" data-le-size-guide-mockups>{…}</script>
     keyed "<Size name>|<Orientation>", e.g. "X-Large|Vertical". */
  function fgSolve(A, b) {
    var n = b.length, M = A.map(function (r, i) { return r.concat([b[i]]); });
    for (var c = 0; c < n; c++) {
      var pv = c; for (var r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[pv][c])) pv = r;
      var t = M[c]; M[c] = M[pv]; M[pv] = t;
      var d = M[c][c] || 1e-9;
      for (var k = c; k <= n; k++) M[c][k] /= d;
      for (var r2 = 0; r2 < n; r2++) { if (r2 === c) continue; var f = M[r2][c]; for (var k2 = c; k2 <= n; k2++) M[r2][k2] -= f * M[c][k2]; }
    }
    return M.map(function (r) { return r[n]; });
  }
  function fgMatrix3d(w, h, dst) {
    var src = [[0, 0], [w, 0], [w, h], [0, h]], A = [], bb = [];
    for (var i = 0; i < 4; i++) { var x = src[i][0], y = src[i][1], X = dst[i][0], Y = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -X * x, -X * y]); bb.push(X);
      A.push([0, 0, 0, x, y, 1, -Y * x, -Y * y]); bb.push(Y); }
    var g = fgSolve(A, bb);
    return 'matrix3d(' + [g[0], g[3], 0, g[6], g[1], g[4], 0, g[7], 0, 0, 1, 0, g[2], g[5], 0, 1].join(',') + ')';
  }
  function fgPrintImg() {
    var el = document.querySelector('.product-gallery__carousel-item.main-frame .main-art-img')
      || document.querySelector('.main-art-img')
      || document.querySelector('.product-gallery__carousel-item.is-selected img')
      || document.querySelector('.product-gallery__image img, .product-gallery img');
    return el ? (el.currentSrc || el.getAttribute('src') || '') : '';
  }
  function fgMockups() {
    var c = document.querySelector('[data-le-size-guide-mockups]');
    if (!c) return {};
    // Tolerate comment-only lines (e.g. the Frame Corner Tool's "// corners order …").
    // Only strips lines that START with // — never touches // inside URLs.
    var txt = (c.textContent || '').replace(/^[ \t]*\/\/.*$/gm, '');
    try { return JSON.parse(txt); } catch (e) { return {}; }
  }
  function compositePanel(kind, sizeName, orientLabel) {
    var m = fgMockups();
    var cfg = (m[sizeName + '|' + orientLabel] || {})[kind];
    if (!cfg || !cfg.img) {
      return '<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;text-align:center;color:#B0ABA2;font-size:12px;padding:16px;background:#F1EFEB;">Add a ' + esc(kind) + ' photo for<br>' + esc(sizeName) + ' · ' + esc(orientLabel) + '</div>';
    }
    var layer = '', art = fgPrintImg();
    if (cfg.corners && cfg.corners.length === 4 && art) {
      var blend = cfg.blend || 'normal', op = cfg.opacity == null ? 1 : cfg.opacity;
      layer = '<div class="fg-warp" data-corners="' + esc(JSON.stringify(cfg.corners)) + '" style="position:absolute;inset:0;overflow:hidden;">'
        + '<img src="' + esc(art) + '" alt="" style="position:absolute;top:0;left:0;transform-origin:0 0;mix-blend-mode:' + esc(blend) + ';opacity:' + op + ';"></div>';
    }
    return '<div style="position:relative;width:100%;height:100%;"><img class="fg-room-photo" src="' + esc(cfg.img) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' + layer + '</div>';
  }
  function applyWarps(panel) {
    Array.prototype.forEach.call(panel.querySelectorAll('.fg-warp'), function (warp) {
      var img = warp.querySelector('img');
      var photo = warp.parentNode && warp.parentNode.querySelector('.fg-room-photo');
      var W = warp.clientWidth, H = warp.clientHeight, corners;
      if (!img || !W || !H) return;
      try { corners = JSON.parse(warp.getAttribute('data-corners')); } catch (e) { return; }
      // The room photo is object-fit:cover (cropped to fill the panel). Map the
      // % corners through the same cover transform so they land on the VISIBLE
      // photo — exactly like the Frame Corner Tool, which showed the photo at
      // its natural aspect. Needs the photo's natural size, so wait for load.
      var nw = photo && photo.naturalWidth, nh = photo && photo.naturalHeight, dst;
      if (nw && nh) {
        var s = Math.max(W / nw, H / nh), dw = nw * s, dh = nh * s, ox = (W - dw) / 2, oy = (H - dh) / 2;
        dst = corners.map(function (p) { return [ox + p[0] / 100 * dw, oy + p[1] / 100 * dh]; });
      } else {
        dst = corners.map(function (p) { return [p[0] / 100 * W, p[1] / 100 * H]; });
        if (photo && !photo.complete) photo.addEventListener('load', function () { applyWarps(panel); }, { once: true });
      }
      img.style.width = W + 'px'; img.style.height = H + 'px'; img.style.transform = fgMatrix3d(W, H, dst);
    });
  }

  /* --------------------------- modal shell -------------------------- */
  function Modal(paintFn) {
    var overlay = document.createElement('div');
    overlay.className = 'fg-modal fg-overlay';
    overlay.setAttribute('hidden', '');
    var panel = document.createElement('div');
    panel.className = 'fg-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    var lastFocus = null;
    overlay.addEventListener('click', function (e) { if (e.target === overlay) api.close(); });
    // iOS Safari: prevent pinch-zooming the page while the modal is open.
    overlay.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    overlay.addEventListener('touchmove', function (e) { if (e.touches && e.touches.length > 1) e.preventDefault(); }, { passive: false });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) api.close();
    });

    var api = {
      panel: panel,
      paint: function () {
        panel.innerHTML = paintFn(api);
        Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-close]'), function (b) {
          b.addEventListener('click', api.close);
        });
        if (api._bind) api._bind(panel);
      },
      open: function () {
        lastFocus = document.activeElement;
        api.paint();
        overlay.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        var c = panel.querySelector('[data-fg-close]');
        if (c && c.focus) c.focus();
      },
      close: function () {
        overlay.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    };
    return api;
  }

  function header(iconKey, eyebrow, title, withPad) {
    return '<div class="fg-head' + (withPad ? ' fg-head--pad' : '') + '">'
      + '<div class="fg-head-row"><div>'
      + '<div class="eyebrow fg-eyebrow-ico">' + ICON[iconKey] + ' ' + esc(eyebrow) + '</div>'
      + '<h3 class="serif fg-title">' + esc(title) + '</h3></div>'
      + '<button type="button" class="fg-close" data-fg-close aria-label="Close">' + ICON.close + '</button>'
      + '</div>';
  }

  function imageBlock(panels, idx) {
    // Grid tracks scale with the panel count so removing a panel (e.g. Styled)
    // doesn't leave an empty column.
    var cols = panels.length === 2 ? '1.15fr 1fr' : panels.length === 3 ? '1.15fr 1fr 1fr' : 'repeat(' + panels.length + ', 1fr)';
    var desktop = '<div class="fg-imgs-desktop" style="grid-template-columns:' + cols + ';">' + panels.map(function (p) { return panelBox(p.inner, p.label); }).join('') + '</div>';
    var cur = panels[idx];
    var mobile = '<div class="fg-imgs-mobile"><div class="fg-swipe" data-fg-swipe>'
      + panelBox(cur.inner, cur.label)
      + '<button type="button" class="fg-arrow fg-arrow--left" data-fg-prev aria-label="Previous">' + ICON.arrowL + '</button>'
      + '<button type="button" class="fg-arrow fg-arrow--right" data-fg-next aria-label="Next">' + ICON.arrowR + '</button>'
      + '</div><div class="fg-dots">'
      + panels.map(function (_, i) { return '<button type="button" class="fg-dot' + (i === idx ? ' is-on' : '') + '" data-fg-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>'; }).join('')
      + '</div></div>';
    return desktop + mobile;
  }

  function bindSwipe(panel, state, set) {
    var sw = panel.querySelector('[data-fg-swipe]');
    var n = state.panels.length;
    function go(d) { set((state.idx + d + n) % n); }
    var prev = panel.querySelector('[data-fg-prev]'); if (prev) prev.addEventListener('click', function () { go(-1); });
    var next = panel.querySelector('[data-fg-next]'); if (next) next.addEventListener('click', function () { go(1); });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-dot]'), function (d) {
      d.addEventListener('click', function () { set(parseInt(d.getAttribute('data-fg-dot'), 10)); });
    });
    if (sw) {
      var x = null;
      sw.addEventListener('touchstart', function (e) { x = e.touches[0].clientX; }, { passive: true });
      sw.addEventListener('touchend', function (e) {
        if (x == null) return;
        var dx = e.changedTouches[0].clientX - x;
        if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        x = null;
      });
    }
  }

  /* --------------------------- Size Guide --------------------------- */
  var sizeGuide;
  // Richer per-size data for the redesigned Size Guide (paper / image / mat /
  // frame dimensions), matching the Claude "Size Guide" export.
  var GUIDE_SIZES = [
    { name: 'Mini', sig: 0.8, frW: 2, code: 'A4', pw: 21, ph: 29.7, iw: 14.7, ih: 20.8, mw: 16.3, mh: 22.4, fw: 24, fh: 33, fd: 3, use: 'Perfect for shelves, desks, and gallery walls — Mini works best in clusters of three or more, or leaning casually against a stack of books.' },
    { name: 'Small', sig: 1, frW: 2, code: 'A3', pw: 29.7, ph: 42, iw: 20.8, ih: 29.4, mw: 22.8, mh: 31.4, fw: 33, fh: 45.4, fd: 3, use: 'A flexible size for hallways, kitchens, and above shelving. Hang in pairs for rhythm, or solo in a compact room.' },
    { name: 'Medium', sig: 1, frW: 3, code: 'A2', pw: 42, ph: 59.4, iw: 29.4, ih: 41.6, mw: 31.4, mh: 43.6, fw: 46, fh: 63.5, fd: 4.5, use: 'The classic living size — at home above a desk, console, or reading chair, where it can be viewed up close.' },
    { name: 'Large', sig: 1.2, frW: 3, code: 'A1', pw: 59.4, ph: 84.1, iw: 47.5, ih: 67.3, mw: 49.9, mh: 69.7, fw: 63.5, fh: 88, fd: 4.5, use: 'Large enough to carry a wall on its own. Ideal above a sofa or bed, hung with its centre at eye level.' },
    { name: 'X-Large', sig: 1.4, frW: 3, code: 'B1', pw: 70.7, ph: 100, iw: 56.6, ih: 80, mw: 59.4, mh: 82.8, fw: 75, fh: 105, fd: 4.5, use: 'A confident solo statement for living and dining rooms — give it breathing room and let it anchor the space.' },
    { name: 'Gallery', sig: 1.6, frW: 3, code: 'A0', pw: 84.1, ph: 118.9, iw: 67.3, ih: 95.1, mw: 70.5, mh: 98.3, fw: 89, fh: 124, fd: 4.5, use: 'Museum scale. Made for generous walls, stairwells, and rooms with high ceilings — best viewed from a few steps back.' },
    { name: 'Grand', sig: 1.8, frW: 3, code: '', pw: 101.6, ph: 143.7, iw: 81.3, ih: 114.9, mw: 84.9, mh: 118.5, fw: 106, fh: 157, fd: 4.5, use: 'An architectural presence for double-height spaces, entries, and wide feature walls.' },
    { name: 'Collector', sig: null, frW: null, code: '', pw: 127, ph: 179.6, iw: 108, ih: 152.7, fw: null, use: 'Commissioned-interior scale — a single work that defines the room. Ships rolled; professional mounting recommended.' },
    { name: 'Statement', sig: null, frW: null, code: '', pw: 152.4, ph: 215.5, iw: 129.5, ih: 183.2, fw: null, use: 'The largest format we print — a full wall given to a single scene. Ships rolled; professional mounting recommended.' }
  ];
  var GUIDE_FCOLS = [{ label: 'Natural', bg: '#BE9558' }, { label: 'White', bg: '#F6F4F0' }, { label: 'Black', bg: '#1C1B19' }];
  var GUIDE_ORI = ['Vertical', 'Horizontal'];

  // ---- "In a room" illustrated scenes — ALL sizes x both orientations ------
  // Ported verbatim from the updated handoff (5 scenes per size per
  // orientation, 90 total). Frame shapes use the __FRAME__ token so companion
  // frames follow the selected frame colour at render time.
  var ROOM_V, ROOM_H;
  (function () {
    var frame2 = '__FRAME__';
    var wood2 = '#C9BFAC', dark2 = '#B8AF9E', leaf2 = '#C4C6B4', shade2 = '#CBC5B8';
    var glass2 = '#E9EAE5', linen2 = '#EDEAE3', linen3 = '#E3DFD5';
    var emptyFrame = function (cx, y, w, h) {
      return [{ cx: cx, y: y, w: w, h: h, bg: frame2 }, { cx: cx, y: y + 2, w: w - 4, h: h - 4, bg: '#FFFFFF' }];
    };
const roomDefsMini = [
      { caption: 'Bedroom shelf — leaned against the wall next to books and a small lamp; paired with a second Mini as a casual diptych.', crop: 60, printCx: -18, surface: 102.5, shapes: [
        { cx: 0, y: 100, w: 110, h: 2.5, bg: wood2 },
        ...emptyFrame(10, 102.5, 24, 33),
        { cx: 32, y: 102.5, w: 22, h: 3, bg: dark2 },
        { cx: 32, y: 105.5, w: 20, h: 2.8, bg: wood2 },
        { cx: 32, y: 108.3, w: 18, h: 2.6, bg: shade2 },
        { cx: 49, y: 102.5, w: 10, h: 1.5, bg: dark2 },
        { cx: 49, y: 104, w: 1.5, h: 13, bg: dark2 },
        { cx: 49, y: 116, w: 12, h: 8, bg: shade2, r: '50% 50% 8% 8%' },
      ]},
      { caption: 'Home-office desk — propped against the wall behind the monitor, with stationery and a plant in front.', crop: 30, printCx: 18, surface: 76.5, shapes: [
        { cx: 0, y: 73, w: 130, h: 3.5, bg: wood2 },
        { cx: -61, y: 30, w: 4, h: 43, bg: wood2 },
        { cx: 61, y: 30, w: 4, h: 43, bg: wood2 },
      ], front: [
        { cx: -18, y: 76.5, w: 18, h: 2, bg: dark2 },
        { cx: -18, y: 78.5, w: 3, h: 9, bg: dark2 },
        { cx: -18, y: 87.5, w: 56, h: 32, bg: dark2, r: '2px' },
        { cx: 42, y: 76.5, w: 6, h: 9, bg: shade2 },
        { cx: 53, y: 76.5, w: 10, h: 9, bg: dark2 },
        { cx: 53, y: 84, w: 18, h: 15, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Hallway console — leaning behind a tray with keys and a bowl; one Small frame hung above.', crop: 20, printCx: 26, surface: 83, shapes: [
        { cx: 0, y: 80, w: 110, h: 3, bg: wood2 },
        { cx: -51, y: 20, w: 3, h: 60, bg: wood2 },
        { cx: 51, y: 20, w: 3, h: 60, bg: wood2 },
        ...emptyFrame(-10, 130, 33, 45.4),
      ], front: [
        { cx: -20, y: 83, w: 26, h: 1.5, bg: dark2 },
        { cx: -20, y: 84.5, w: 12, h: 5.5, bg: shade2, r: '0 0 45% 45%' },
      ]},
      { caption: 'Kitchen open shelf — leaned beside cookbooks and a ceramic jug; small art in a functional space.', crop: 85, printCx: 2, surface: 143, shapes: [
        { cx: 0, y: 140, w: 120, h: 3, bg: wood2 },
        { cx: -38, y: 143, w: 4, h: 24, bg: dark2 },
        { cx: -33, y: 143, w: 4.5, h: 26, bg: wood2 },
        { cx: -28, y: 143, w: 4, h: 22, bg: shade2 },
        { cx: -23, y: 143, w: 5, h: 25, bg: dark2 },
        { cx: 30, y: 143, w: 14, h: 18, bg: shade2, r: '35% 35% 45% 45%' },
      ]},
      { caption: 'Child\’s room dresser — leaned next to toys and a framed photo; part of a small, personal vignette.', crop: 0, printCx: 2, surface: 75, shapes: [
        { cx: -43, y: 0, w: 4, h: 6, bg: dark2 },
        { cx: 43, y: 0, w: 4, h: 6, bg: dark2 },
        { cx: 0, y: 6, w: 92, h: 69, bg: wood2, r: '3px' },
        { cx: -30, y: 75, w: 12, h: 12, bg: shade2, r: '50%' },
        { cx: -42, y: 75, w: 8, h: 8, bg: dark2 },
        ...emptyFrame(31, 75, 13, 18),
      ]},
    ];
    const roomDefsSmall = [
      { caption: 'Hung beside a bedroom wardrobe or door, filling that narrow strip of wall that usually feels empty; clean floor, a simple rug.', crop: 0, printCx: 14, surface: 127, shapes: [
        { cx: -56, y: 0, w: 52, h: 216, bg: wood2 },
        { cx: -33, y: 96, w: 3, h: 16, bg: dark2 },
        { cx: 24, y: 0, w: 84, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'Above a slim shoe cabinet in the hallway, with a Mini leaned on the cabinet and a bowl for keys \— a casual everyday entry.', crop: 0, printCx: -10, surface: 118, shapes: [
        { cx: 0, y: 0, w: 96, h: 50, bg: wood2, r: '2px' },
        { cx: 0, y: 24, w: 96, h: 1.5, bg: dark2 },
        ...emptyFrame(34, 50, 24, 33),
        { cx: -28, y: 50, w: 22, h: 1.5, bg: dark2 },
        { cx: -28, y: 51.5, w: 10, h: 5, bg: shade2, r: '0 0 45% 45%' },
      ]},
      { caption: 'Above a bar cart, centred with two smaller frames flanking it as a simple triptych; bottles and glassware give scale.', crop: 0, printCx: 0, surface: 127, shapes: [
        { cx: -34, y: 3, w: 3, h: 75, bg: dark2 },
        { cx: 34, y: 3, w: 3, h: 75, bg: dark2 },
        { cx: -34, y: 0, w: 6, h: 6, bg: dark2, r: '50%' },
        { cx: 34, y: 0, w: 6, h: 6, bg: dark2, r: '50%' },
        { cx: 0, y: 34, w: 76, h: 3, bg: wood2 },
        { cx: 0, y: 78, w: 76, h: 3, bg: wood2 },
        { cx: -18, y: 81, w: 5, h: 22, bg: dark2 },
        { cx: -8, y: 81, w: 6, h: 17, bg: shade2 },
        { cx: 2, y: 81, w: 5, h: 13, bg: glass2 },
        ...emptyFrame(-42, 134, 24, 33),
        ...emptyFrame(42, 134, 24, 33),
      ]},
      { caption: 'On the wall next to a reading chair and floor lamp, a vertical focal point in a small nook \— chair, lamp, one side table.', crop: 0, printCx: -32, surface: 127, shapes: [
        { cx: -25, y: 0, w: 3, h: 38, bg: dark2 },
        { cx: -13, y: 0, w: 3, h: 38, bg: dark2 },
        { cx: -19, y: 38, w: 30, h: 2.5, bg: wood2 },
        { cx: 28, y: 0, w: 4, h: 12, bg: dark2 },
        { cx: 28, y: 10, w: 66, h: 22, bg: shade2, r: '4px' },
        { cx: 28, y: 30, w: 66, h: 42, bg: shade2, r: '9px 9px 0 0' },
        { cx: 70, y: 0, w: 3, h: 150, bg: dark2 },
        { cx: 70, y: 150, w: 28, h: 20, bg: linen2, r: '50% 50% 8% 8%' },
      ]},
      { caption: 'In a powder room on the wall opposite the mirror, above a towel rail beside a minimal vanity \— small but impactful in compact spaces.', crop: 0, printCx: 26, surface: 122, shapes: [
        { cx: -38, y: 0, w: 54, h: 72, bg: wood2, r: '2px' },
        { cx: -38, y: 72, w: 58, h: 4, bg: '#FFFFFF' },
        { cx: -38, y: 40, w: 54, h: 1.5, bg: dark2 },
        { cx: 26, y: 92, w: 60, h: 2, bg: dark2 },
        { cx: 14, y: 64, w: 20, h: 28, bg: linen2, r: '2px' },
        { cx: 38, y: 64, w: 16, h: 28, bg: linen3, r: '2px' },
      ]},
    ];
    const roomDefsMedium = [
      { caption: 'In a home office, centred above the desk — a tall work you look up to between tasks.', crop: 25, printCx: -6, surface: 118, shapes: [
        { cx: 0, y: 73, w: 140, h: 3.5, bg: wood2 },
        { cx: -66, y: 25, w: 4, h: 48, bg: wood2 },
        { cx: 66, y: 25, w: 4, h: 48, bg: wood2 },
        { cx: 50, y: 76.5, w: 12, h: 2, bg: dark2 },
        { cx: 50, y: 78, w: 2, h: 26, bg: dark2 },
        { cx: 50, y: 102, w: 16, h: 10, bg: shade2, r: '50% 50% 8% 8%' },
        { cx: -46, y: 76.5, w: 20, h: 2.5, bg: dark2 },
      ]},
      { caption: 'Beside a sofa arm, on the tall narrow wall between the sofa and a doorway \— a vertical Medium without going above the couch.', crop: 8, printCx: -8, surface: 118, shapes: [
        { cx: -70, y: 0, w: 8, h: 214, bg: wood2 },
        { cx: 66, y: 0, w: 6, h: 14, bg: dark2 },
        { cx: 40, y: 12, w: 26, h: 30, bg: shade2, r: '4px' },
        { cx: 66, y: 12, w: 44, h: 56, bg: shade2, r: '9px 9px 0 0' },
      ]},
      { caption: 'Above a queen bed as a diptych: your print with a complementary Medium beside it; low headboard, simple bedside tables.', crop: 0, printCx: -26, surface: 118, shapes: [
        { cx: 0, y: 12, w: 166, h: 68, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 8, w: 160, h: 28, bg: '#D9D4C8' },
        { cx: 0, y: 30, w: 160, h: 22, bg: linen2, r: '4px' },
        { cx: -38, y: 52, w: 44, h: 16, bg: '#FFFFFF', r: '6px' },
        { cx: 38, y: 52, w: 44, h: 16, bg: '#FFFFFF', r: '6px' },
        { cx: -104, y: 0, w: 36, h: 45, bg: wood2, r: '2px' },
        { cx: 104, y: 0, w: 36, h: 45, bg: wood2, r: '2px' },
        { cx: -104, y: 45, w: 4, h: 11, bg: dark2 },
        { cx: 104, y: 45, w: 4, h: 11, bg: dark2 },
        { cx: -104, y: 54, w: 14, h: 9, bg: linen2, r: '50% 50% 8% 8%' },
        { cx: 104, y: 54, w: 14, h: 9, bg: linen2, r: '50% 50% 8% 8%' },
        ...emptyFrame(26, 118, 46, 63.5),
      ]},
      { caption: 'In a dining-room corner, centred above a small sideboard with bottles and glassware \— art plus a little bar, for real homes.', crop: 0, printCx: 0, surface: 118, shapes: [
        { cx: -46, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 46, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 104, h: 60, bg: wood2, r: '3px' },
        { cx: -24, y: 68, w: 6, h: 27, bg: dark2 },
        { cx: -12, y: 68, w: 5, h: 21, bg: shade2 },
        { cx: 0, y: 68, w: 6, h: 16, bg: glass2 },
        { cx: 28, y: 60, w: 8, h: 10, bg: dark2 },
        { cx: 28, y: 68, w: 16, h: 15, bg: leaf2, r: '50%' },
      ]},
      { caption: 'In a living-room corner above a reading armchair, a floor plant softening the edge — a calm vertical anchor.', crop: 0, printCx: -12, surface: 118, shapes: [
        { cx: -12, y: 0, w: 4, h: 12, bg: dark2 },
        { cx: -12, y: 10, w: 74, h: 24, bg: shade2, r: '4px' },
        { cx: -12, y: 32, w: 74, h: 44, bg: shade2, r: '9px 9px 0 0' },
        { cx: 58, y: 0, w: 24, h: 21, bg: dark2 },
        { cx: 58, y: 18, w: 46, h: 62, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
    ];
    const roomDefsLarge = [
      { caption: 'Centred on the main living-room wall \— a low sideboard beneath, a plant to one side; the primary art focus, away from the TV.', crop: 0, printCx: 0, surface: 92, shapes: [
        { cx: -46, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 46, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 110, h: 56, bg: wood2, r: '3px' },
        { cx: 80, y: 0, w: 26, h: 22, bg: dark2 },
        { cx: 80, y: 19, w: 50, h: 66, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
      { caption: 'The wall you face as you walk through the front door \— nothing else on it, so the Large print is the clear hero.', crop: 0, printCx: 0, surface: 106, shapes: [
        { cx: 0, y: 0, w: 120, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'Behind a big desk or drawing table \— a strong vertical presence in a creative workspace.', crop: 0, printCx: 0, surface: 100, shapes: [
        { cx: 0, y: 73, w: 150, h: 3.5, bg: wood2 },
        { cx: -71, y: 0, w: 4, h: 73, bg: wood2 },
        { cx: 71, y: 0, w: 4, h: 73, bg: wood2 },
      ], front: [
        { cx: -50, y: 76.5, w: 18, h: 2, bg: dark2 },
        { cx: -50, y: 78.5, w: 3, h: 9, bg: dark2 },
        { cx: -50, y: 87.5, w: 40, h: 24, bg: dark2, r: '2px' },
        { cx: 55, y: 76.5, w: 10, h: 9, bg: dark2 },
        { cx: 55, y: 84, w: 18, h: 15, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Midway down a long corridor with just a runner below \— one Large frame carrying the whole hallway.', crop: 0, printCx: 0, surface: 106, shapes: [
        { cx: 0, y: 0, w: 150, h: 4, bg: linen3 },
        { cx: 0, y: 4, w: 150, h: 1, bg: dark2 },
      ]},
      { caption: 'On the wall beside the bed, next to a tall wardrobe \— height and presence without competing with the headboard.', crop: 0, printCx: 18, surface: 100, shapes: [
        { cx: -62, y: 0, w: 54, h: 216, bg: wood2 },
        { cx: -38, y: 96, w: 3, h: 16, bg: dark2 },
      ]},
    ];
    const roomDefsXLarge = [
      { caption: 'Between two full-height windows with a low bench underneath \— the vertical emphasises the ceiling height.', crop: 0, printCx: 0, surface: 90, shapes: [
        { cx: -92, y: 0, w: 70, h: 230, bg: glass2 },
        { cx: 92, y: 0, w: 70, h: 230, bg: glass2 },
        { cx: -92, y: 112, w: 70, h: 3, bg: '#FFFFFF' },
        { cx: 92, y: 112, w: 70, h: 3, bg: '#FFFFFF' },
        { cx: -40, y: 0, w: 4, h: 32, bg: wood2 },
        { cx: 40, y: 0, w: 4, h: 32, bg: wood2 },
        { cx: 0, y: 32, w: 110, h: 6, bg: wood2, r: '2px' },
      ]},
      { caption: 'Anchoring a reading corner in an open-plan space \— armchair, side table, and floor lamp beside one big vertical.', crop: 0, printCx: -16, surface: 97, shapes: [
        { cx: 34, y: 0, w: 4, h: 12, bg: dark2 },
        { cx: 74, y: 0, w: 4, h: 12, bg: dark2 },
        { cx: 54, y: 10, w: 78, h: 26, bg: shade2, r: '4px' },
        { cx: 54, y: 34, w: 78, h: 46, bg: shade2, r: '10px 10px 0 0' },
        { cx: 102, y: 0, w: 3, h: 150, bg: dark2 },
        { cx: 102, y: 150, w: 28, h: 20, bg: linen2, r: '50% 50% 8% 8%' },
        { cx: 6, y: 0, w: 3, h: 45, bg: dark2 },
        { cx: 6, y: 45, w: 26, h: 2.5, bg: wood2 },
      ]},
      { caption: 'One side of a wide hallway, a simple bench beneath and nothing else \— a bold corridor statement.', crop: 0, printCx: 0, surface: 85, shapes: [
        { cx: -48, y: 0, w: 4, h: 38, bg: wood2 },
        { cx: 48, y: 0, w: 4, h: 38, bg: wood2 },
        { cx: 0, y: 38, w: 130, h: 7, bg: wood2, r: '2px' },
      ]},
      { caption: 'On the wall perpendicular to the dining table \— a sideboard and a few minimal objects below; the art you look at while dining.', crop: 0, printCx: 0, surface: 95, shapes: [
        { cx: -50, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 50, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 120, h: 60, bg: wood2, r: '3px' },
        { cx: -30, y: 68, w: 8, h: 18, bg: dark2 },
        { cx: 30, y: 68, w: 14, h: 12, bg: shade2 },
      ]},
      { caption: 'A studio or creative loft \— above a low daybed, informal seating with serious art scale.', crop: 0, printCx: 0, surface: 92, shapes: [
        { cx: 0, y: 0, w: 190, h: 12, bg: wood2, r: '2px' },
        { cx: 0, y: 12, w: 190, h: 22, bg: shade2, r: '4px' },
        { cx: -62, y: 34, w: 40, h: 16, bg: linen2, r: '4px' },
        { cx: 62, y: 34, w: 40, h: 16, bg: linen3, r: '4px' },
      ]},
    ];
    const roomDefsGallery = [
      { caption: 'Centred opposite the sofa with just a slim console below \— one Gallery vertical instead of a busy gallery wall.', crop: 0, printCx: 0, surface: 103, shapes: [
        { cx: -55, y: 0, w: 3, h: 76, bg: wood2 },
        { cx: 55, y: 0, w: 3, h: 76, bg: wood2 },
        { cx: 0, y: 76, w: 120, h: 3, bg: wood2 },
      ]},
      { caption: 'The very end of a long corridor, filling most of the wall you walk toward; a small plant below for scale.', crop: 0, printCx: 0, surface: 88, shapes: [
        { cx: 64, y: 0, w: 24, h: 21, bg: dark2 },
        { cx: 64, y: 18, w: 46, h: 62, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
      { caption: 'Directly opposite the bed with minimal furniture \— the single large artwork you wake up to.', crop: 0, printCx: 0, surface: 88, shapes: [
        { cx: 0, y: 0, w: 130, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'Above a long buffet in the dining room, bottles and objects arranged below \— a refined entertaining wall.', crop: 0, printCx: 0, surface: 100, shapes: [
        { cx: -60, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 60, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 150, h: 62, bg: wood2, r: '3px' },
        { cx: -36, y: 70, w: 6, h: 26, bg: dark2 },
        { cx: -25, y: 70, w: 5, h: 20, bg: shade2 },
        { cx: -15, y: 70, w: 6, h: 15, bg: glass2 },
        { cx: 38, y: 70, w: 16, h: 14, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Centred in a stairwell void, visible from the stairs and the room beyond \— no competing frames, pure vertical impact.', crop: 0, printCx: -12, surface: 100, shapes: [
        { cx: 52, y: 0, w: 110, h: 9, bg: wood2 },
        { cx: 66, y: 9, w: 82, h: 9, bg: shade2 },
        { cx: 80, y: 18, w: 54, h: 9, bg: wood2 },
        { cx: 94, y: 27, w: 26, h: 9, bg: shade2 },
      ]},
    ];
    const roomDefsMiniH = [
      { caption: 'Above a narrow writing desk \— a slim floating shelf-desk with a single lamp beneath.', crop: 30, printCx: 0, surface: 102, shapes: [
        { cx: 0, y: 74, w: 64, h: 2.5, bg: wood2 },
        { cx: 22, y: 76.5, w: 8, h: 1.2, bg: dark2 },
        { cx: 22, y: 77.5, w: 1.2, h: 11, bg: dark2 },
        { cx: 22, y: 87.5, w: 9, h: 6, bg: shade2, r: '50% 50% 8% 8%' },
      ]},
      { caption: 'On a short kitchen wall above one small open shelf holding a few jars.', crop: 60, printCx: 0, surface: 126, shapes: [
        { cx: 0, y: 105, w: 56, h: 2.5, bg: wood2 },
        { cx: -16, y: 107.5, w: 7, h: 10, bg: glass2 },
        { cx: -6, y: 107.5, w: 6, h: 8, bg: shade2 },
        { cx: 4, y: 107.5, w: 6, h: 9, bg: glass2 },
        { cx: 16, y: 107.5, w: 2, h: 11, bg: dark2 },
      ]},
      { caption: 'Above a low, narrow toy shelf \— a fun, approachable scale for a child\’s room.', crop: 0, printCx: 0, surface: 72, shapes: [
        { cx: 0, y: 0, w: 58, h: 42, bg: wood2, r: '2px' },
        { cx: 0, y: 21, w: 58, h: 1.2, bg: dark2 },
        { cx: -16, y: 42, w: 9, h: 8, bg: shade2, r: '50% 50% 20% 20%' },
        { cx: 12, y: 42, w: 7, h: 7, bg: leaf2, r: '2px' },
        { cx: 22, y: 42, w: 5, h: 9, bg: linen3, r: '40% 40% 8% 8%' },
      ]},
      { caption: 'Above a row of wall hooks by the front door \— keys and bags below, a simple welcome moment.', crop: 45, printCx: 0, surface: 124, shapes: [
        { cx: 0, y: 106, w: 52, h: 2, bg: wood2 },
        { cx: -16, y: 102, w: 1.6, h: 4, bg: dark2 },
        { cx: 0, y: 102, w: 1.6, h: 4, bg: dark2 },
        { cx: 16, y: 102, w: 1.6, h: 4, bg: dark2 },
        { cx: -16, y: 84, w: 11, h: 18, bg: linen3, r: '15% 15% 40% 40%' },
        { cx: 16, y: 90, w: 8, h: 12, bg: shade2, r: '10% 10% 30% 30%' },
      ]},
      { caption: 'On a small wall above a towel hook \— a calm horizontal moment in a functional space.', crop: 20, printCx: 0, surface: 108, shapes: [
        { cx: -8, y: 92, w: 30, h: 1.6, bg: dark2 },
        { cx: -14, y: 66, w: 12, h: 26, bg: linen2, r: '2px' },
        { cx: 2, y: 66, w: 10, h: 26, bg: linen3, r: '2px' },
      ]},
    ];
    const roomDefsSmallH = [
      { caption: 'Centred above a reading chair with one small side table \— a modest living-room focal point.', crop: 0, printCx: 0, surface: 100, shapes: [
        { cx: -6, y: 0, w: 4, h: 10, bg: dark2 },
        { cx: -6, y: 8, w: 62, h: 22, bg: shade2, r: '4px' },
        { cx: -6, y: 28, w: 62, h: 40, bg: shade2, r: '9px 9px 0 0' },
        { cx: 44, y: 0, w: 3, h: 30, bg: dark2 },
        { cx: 44, y: 30, w: 22, h: 2.2, bg: wood2 },
        { cx: 44, y: 32, w: 7, h: 6, bg: linen2, r: '40% 40% 8% 8%' },
      ]},
      { caption: 'Above a small round caf\é table for two \— coffee and quiet mornings.', crop: 0, printCx: 0, surface: 104, shapes: [
        { cx: 0, y: 72, w: 56, h: 2.4, bg: wood2 },
        { cx: 0, y: 0, w: 3.5, h: 72, bg: dark2 },
        { cx: -26, y: 0, w: 2.6, h: 45, bg: dark2 },
        { cx: -26, y: 43, w: 17, h: 29, bg: shade2, r: '4px 4px 0 0' },
        { cx: 26, y: 0, w: 2.6, h: 45, bg: dark2 },
        { cx: 26, y: 43, w: 17, h: 29, bg: shade2, r: '4px 4px 0 0' },
        { cx: 6, y: 74.4, w: 5, h: 4, bg: glass2 },
        { cx: -7, y: 74.4, w: 8, h: 1.8, bg: linen3 },
      ]},
      { caption: 'Above a narrow entry console with a single bowl on top \— the first thing guests see.', crop: 0, printCx: 0, surface: 110, shapes: [
        { cx: -34, y: 0, w: 2.6, h: 80, bg: wood2 },
        { cx: 34, y: 0, w: 2.6, h: 80, bg: wood2 },
        { cx: 0, y: 80, w: 78, h: 2.4, bg: wood2 },
        { cx: 0, y: 82.4, w: 14, h: 4, bg: shade2, r: '0 0 45% 45%' },
      ]},
      { caption: 'Above a slim bar cart \— a compact personality piece over bottles and glassware.', crop: 0, printCx: 0, surface: 112, shapes: [
        { cx: -22, y: 2, w: 2.4, h: 78, bg: dark2 },
        { cx: 22, y: 2, w: 2.4, h: 78, bg: dark2 },
        { cx: -22, y: 0, w: 5, h: 5, bg: dark2, r: '50%' },
        { cx: 22, y: 0, w: 5, h: 5, bg: dark2, r: '50%' },
        { cx: 0, y: 36, w: 50, h: 2.4, bg: wood2 },
        { cx: 0, y: 80, w: 50, h: 2.4, bg: wood2 },
        { cx: -12, y: 82.4, w: 4, h: 18, bg: dark2 },
        { cx: -4, y: 82.4, w: 4.5, h: 14, bg: shade2 },
        { cx: 4, y: 82.4, w: 4, h: 11, bg: glass2 },
      ]},
      { caption: 'Two Small horizontals in a line along a corridor \— a simple picture-rail effect.', crop: 40, printCx: -28, surface: 118, shapes: [
        { cx: 0, y: 96, w: 130, h: 3.5, bg: linen3 },
        { cx: 0, y: 99.5, w: 130, h: 1, bg: dark2 },
        ...emptyFrame(28, 118, 45.4, 33),
      ]},
    ];
    const roomDefsMediumH = [
      { caption: 'Centred above a single bed in a guest room \— closely tracking the mattress width.', crop: 0, printCx: 0, surface: 92, shapes: [
        { cx: 0, y: 10, w: 100, h: 58, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 6, w: 94, h: 26, bg: '#D9D4C8' },
        { cx: 0, y: 28, w: 94, h: 20, bg: linen2, r: '4px' },
        { cx: 0, y: 48, w: 42, h: 14, bg: '#FFFFFF', r: '6px' },
        { cx: 64, y: 0, w: 26, h: 42, bg: wood2, r: '2px' },
        { cx: 64, y: 42, w: 11, h: 7, bg: linen2, r: '50% 50% 8% 8%' },
      ]},
      { caption: 'Centred above a compact loveseat \— well-proportioned for a smaller seating nook.', crop: 0, printCx: 0, surface: 98, shapes: [
        { cx: -56, y: 0, w: 9, h: 60, bg: shade2, r: '9px 9px 0 0' },
        { cx: 56, y: 0, w: 9, h: 60, bg: shade2, r: '9px 9px 0 0' },
        { cx: 0, y: 13, w: 103, h: 47, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 11, w: 103, h: 21, bg: linen2, r: '4px' },
        { cx: -26, y: 30, w: 26, h: 16, bg: '#FFFFFF', r: '4px' },
        { cx: 26, y: 30, w: 26, h: 16, bg: linen3, r: '4px' },
      ]},
      { caption: 'Above a mid-length console with a lamp and an object or two beneath.', crop: 0, printCx: 0, surface: 95, shapes: [
        { cx: -40, y: 0, w: 3.5, h: 8, bg: dark2 },
        { cx: 40, y: 0, w: 3.5, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 96, h: 58, bg: wood2, r: '3px' },
        { cx: -32, y: 66, w: 9, h: 1.8, bg: dark2 },
        { cx: -32, y: 67.8, w: 1.4, h: 11, bg: dark2 },
        { cx: -32, y: 77, w: 11, h: 7, bg: shade2, r: '50% 50% 8% 8%' },
        { cx: 30, y: 66, w: 12, h: 3.5, bg: linen3 },
      ]},
      { caption: 'Above a small dining table for two to four \— anchoring a compact dining spot.', crop: 0, printCx: 0, surface: 100, shapes: [
        { cx: 0, y: 72, w: 88, h: 3, bg: wood2 },
        { cx: -38, y: 0, w: 3.5, h: 72, bg: dark2 },
        { cx: 38, y: 0, w: 3.5, h: 72, bg: dark2 },
        { cx: -14, y: 0, w: 2.8, h: 47, bg: dark2 },
        { cx: -14, y: 45, w: 19, h: 30, bg: shade2, r: '4px 4px 0 0' },
        { cx: 14, y: 0, w: 2.8, h: 47, bg: dark2 },
        { cx: 14, y: 45, w: 19, h: 30, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 75, w: 10, h: 2.6, bg: glass2 },
      ]},
      { caption: 'Above a low, compact credenza behind the desk chair \— a friendly office art line.', crop: 0, printCx: 0, surface: 92, shapes: [
        { cx: 0, y: 0, w: 92, h: 60, bg: wood2, r: '2px' },
        { cx: 0, y: 30, w: 92, h: 1.4, bg: dark2 },
        { cx: -32, y: 60, w: 12, h: 9, bg: shade2 },
        { cx: 32, y: 60, w: 6, h: 6, bg: dark2 },
        { cx: 32, y: 64, w: 12, h: 10, bg: leaf2, r: '50%' },
      ]},
    ];
    const roomDefsLargeH = [
      { caption: 'Centred above a loveseat with side tables \— tracking the sofa\’s width for a balanced living room.', crop: 0, printCx: 0, surface: 98, shapes: [
        { cx: -70, y: 0, w: 10, h: 60, bg: shade2, r: '9px 9px 0 0' },
        { cx: 70, y: 0, w: 10, h: 60, bg: shade2, r: '9px 9px 0 0' },
        { cx: 0, y: 13, w: 130, h: 47, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 11, w: 130, h: 21, bg: linen2, r: '4px' },
        { cx: -32, y: 30, w: 30, h: 16, bg: '#FFFFFF', r: '4px' },
        { cx: 32, y: 30, w: 30, h: 16, bg: linen3, r: '4px' },
        { cx: 98, y: 0, w: 3, h: 40, bg: dark2 },
        { cx: 98, y: 40, w: 24, h: 2.4, bg: wood2 },
      ]},
      { caption: 'Centred above a medium-length dining buffet \— the primary dining-room artwork.', crop: 0, printCx: 0, surface: 96, shapes: [
        { cx: -60, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 60, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 138, h: 56, bg: wood2, r: '3px' },
        { cx: -48, y: 64, w: 5, h: 20, bg: dark2 },
        { cx: -40, y: 64, w: 4.5, h: 15, bg: shade2 },
        { cx: 48, y: 64, w: 7, h: 8, bg: dark2 },
        { cx: 48, y: 69, w: 15, h: 12, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Where the TV could go \— above a low media console, art as the focus instead of a screen.', crop: 0, printCx: 0, surface: 80, shapes: [
        { cx: 0, y: 0, w: 150, h: 42, bg: wood2, r: '2px' },
        { cx: 0, y: 21, w: 150, h: 1.4, bg: dark2 },
        { cx: -56, y: 42, w: 13, h: 9, bg: shade2 },
        { cx: 56, y: 42, w: 7, h: 7, bg: dark2 },
        { cx: 56, y: 47, w: 14, h: 12, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Above a bench in a generous entryway \— the print sized to the bench below it.', crop: 0, printCx: 0, surface: 90, shapes: [
        { cx: 0, y: 40, w: 104, h: 4, bg: wood2 },
        { cx: -44, y: 0, w: 4, h: 40, bg: dark2 },
        { cx: 44, y: 0, w: 4, h: 40, bg: dark2 },
        { cx: -28, y: 44, w: 16, h: 4, bg: linen3, r: '3px' },
        { cx: 0, y: 0, w: 140, h: 3.5, bg: linen3, r: '50%' },
      ]},
      { caption: 'Behind an armchair grouping on an open-plan wall \— a clear anchor for the seating area.', crop: 0, printCx: 0, surface: 95, shapes: [
        { cx: -62, y: 0, w: 7, h: 9, bg: dark2 },
        { cx: -62, y: 7, w: 48, h: 22, bg: shade2, r: '4px' },
        { cx: -62, y: 27, w: 48, h: 36, bg: shade2, r: '9px 9px 0 0' },
        { cx: 62, y: 0, w: 7, h: 9, bg: dark2 },
        { cx: 62, y: 7, w: 48, h: 22, bg: shade2, r: '4px' },
        { cx: 62, y: 27, w: 48, h: 36, bg: shade2, r: '9px 9px 0 0' },
      ], front: [
        { cx: 0, y: 26, w: 56, h: 2.6, bg: wood2 },
        { cx: 0, y: 0, w: 3.5, h: 26, bg: wood2 },
        { cx: -10, y: 28.6, w: 12, h: 2, bg: linen3 },
        { cx: 12, y: 28.6, w: 6, h: 4, bg: glass2 },
      ]},
    ];
    const roomDefsXLargeH = [
      { caption: 'Centred above a standard three-seat sofa \— a substantial anchor for the main seating area.', crop: 0, printCx: 0, surface: 98, shapes: [
        { cx: -95, y: 0, w: 11, h: 62, bg: shade2, r: '9px 9px 0 0' },
        { cx: 95, y: 0, w: 11, h: 62, bg: shade2, r: '9px 9px 0 0' },
        { cx: 0, y: 13, w: 179, h: 49, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 11, w: 179, h: 23, bg: linen2, r: '4px' },
        { cx: -52, y: 32, w: 38, h: 18, bg: '#FFFFFF', r: '4px' },
        { cx: 0, y: 32, w: 38, h: 18, bg: linen3, r: '4px' },
        { cx: 52, y: 32, w: 38, h: 18, bg: '#FFFFFF', r: '4px' },
      ]},
      { caption: 'Centred above a queen bed with matching bedside tables \— tracking the mattress width closely.', crop: 0, printCx: 0, surface: 98, shapes: [
        { cx: 0, y: 12, w: 166, h: 68, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 8, w: 160, h: 28, bg: '#D9D4C8' },
        { cx: 0, y: 30, w: 160, h: 22, bg: linen2, r: '4px' },
        { cx: -38, y: 52, w: 44, h: 16, bg: '#FFFFFF', r: '6px' },
        { cx: 38, y: 52, w: 44, h: 16, bg: '#FFFFFF', r: '6px' },
        { cx: -106, y: 0, w: 36, h: 45, bg: wood2, r: '2px' },
        { cx: 106, y: 0, w: 36, h: 45, bg: wood2, r: '2px' },
        { cx: -106, y: 45, w: 14, h: 9, bg: linen2, r: '50% 50% 8% 8%' },
        { cx: 106, y: 45, w: 14, h: 9, bg: linen2, r: '50% 50% 8% 8%' },
      ]},
      { caption: 'Above a six-seat dining table \— matching its length for a confident dining-room statement.', crop: 0, printCx: 0, surface: 102, shapes: [
        { cx: 0, y: 74, w: 180, h: 3.5, bg: wood2 },
        { cx: -80, y: 0, w: 4.5, h: 74, bg: dark2 },
        { cx: 80, y: 0, w: 4.5, h: 74, bg: dark2 },
        { cx: -50, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: -50, y: 45, w: 22, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: 0, y: 45, w: 22, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 50, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: 50, y: 45, w: 22, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 77.5, w: 14, h: 2.8, bg: glass2 },
      ]},
      { caption: 'Above a long sideboard \— the panorama spans most of its length.', crop: 0, printCx: 0, surface: 95, shapes: [
        { cx: -78, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 78, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 172, h: 56, bg: wood2, r: '3px' },
        { cx: -62, y: 64, w: 5, h: 20, bg: dark2 },
        { cx: -54, y: 64, w: 4.5, h: 15, bg: shade2 },
        { cx: 62, y: 64, w: 7, h: 8, bg: dark2 },
        { cx: 62, y: 69, w: 15, h: 12, bg: leaf2, r: '50%' },
      ]},
      { caption: 'Above a bank of desks in a studio \— a continuous art band across the workspace.', crop: 20, printCx: 0, surface: 100, shapes: [
        { cx: 0, y: 73, w: 210, h: 3.5, bg: wood2 },
        { cx: -100, y: 20, w: 4, h: 53, bg: wood2 },
        { cx: 0, y: 20, w: 4, h: 53, bg: wood2 },
        { cx: 100, y: 20, w: 4, h: 53, bg: wood2 },
      ], front: [
        { cx: -55, y: 76.5, w: 30, h: 2, bg: dark2 },
        { cx: -55, y: 78.5, w: 26, h: 16, bg: dark2, r: '2px' },
        { cx: 50, y: 76.5, w: 30, h: 2, bg: dark2 },
        { cx: 50, y: 78.5, w: 26, h: 16, bg: dark2, r: '2px' },
      ]},
    ];
    const roomDefsGalleryH = [
      { caption: 'Above a full-length sofa \— spanning most of its width, a true living-room hero piece.', crop: 0, printCx: 0, surface: 96, shapes: [
        { cx: -110, y: 0, w: 12, h: 64, bg: shade2, r: '9px 9px 0 0' },
        { cx: 110, y: 0, w: 12, h: 64, bg: shade2, r: '9px 9px 0 0' },
        { cx: 0, y: 14, w: 208, h: 50, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 12, w: 208, h: 24, bg: linen2, r: '4px' },
        { cx: -60, y: 34, w: 42, h: 20, bg: '#FFFFFF', r: '4px' },
        { cx: 0, y: 34, w: 42, h: 20, bg: linen3, r: '4px' },
        { cx: 60, y: 34, w: 42, h: 20, bg: '#FFFFFF', r: '4px' },
      ]},
      { caption: 'Centred above a king bed \— closely tracking the mattress width for a substantial bedroom statement.', crop: 0, printCx: 0, surface: 95, shapes: [
        { cx: 0, y: 12, w: 206, h: 70, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 8, w: 200, h: 28, bg: '#D9D4C8' },
        { cx: 0, y: 30, w: 200, h: 24, bg: linen2, r: '4px' },
        { cx: -50, y: 54, w: 52, h: 18, bg: '#FFFFFF', r: '6px' },
        { cx: 50, y: 54, w: 52, h: 18, bg: '#FFFFFF', r: '6px' },
        { cx: -128, y: 0, w: 40, h: 48, bg: wood2, r: '2px' },
        { cx: 128, y: 0, w: 40, h: 48, bg: wood2, r: '2px' },
      ]},
      { caption: 'Above a dining table seating eight or more \— a restaurant-scale focal point.', crop: 0, printCx: 0, surface: 102, shapes: [
        { cx: 0, y: 74, w: 240, h: 4, bg: wood2 },
        { cx: -106, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: 106, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: -70, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: -70, y: 45, w: 24, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: -23, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: -23, y: 45, w: 24, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 23, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: 23, y: 45, w: 24, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 70, y: 0, w: 3, h: 47, bg: dark2 },
        { cx: 70, y: 45, w: 24, h: 31, bg: shade2, r: '4px 4px 0 0' },
      ]},
      { caption: 'In a spacious reception or wide hallway, centred above a long bench \— a public, gallery-like hanging.', crop: 0, printCx: 0, surface: 94, shapes: [
        { cx: 0, y: 42, w: 160, h: 4, bg: wood2 },
        { cx: -68, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 68, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 0, y: 0, w: 210, h: 3.5, bg: linen3, r: '50%' },
      ]},
      { caption: 'On the longest wall of a loft studio, above minimal storage \— one strong horizontal line grounding the room.', crop: 0, printCx: 0, surface: 90, shapes: [
        { cx: -40, y: 0, w: 130, h: 42, bg: wood2, r: '2px' },
        { cx: -40, y: 21, w: 130, h: 1.4, bg: dark2 },
        { cx: 70, y: 0, w: 7, h: 7, bg: dark2 },
        { cx: 70, y: 5, w: 16, h: 13, bg: leaf2, r: '50%' },
        { cx: 100, y: 0, w: 18, h: 16, bg: dark2 },
        { cx: 100, y: 14, w: 34, h: 44, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
    ];
    const roomDefsGrandV = [
      { caption: 'Filling the tall, narrow wall beside a fireplace \— floor to near-ceiling presence.', crop: 0, printCx: -75, surface: 32, shapes: [
        { cx: 62, y: 0, w: 120, h: 112, bg: linen3, r: '2px' },
        { cx: 62, y: 12, w: 56, h: 62, bg: dark2, r: '2px 2px 0 0' },
        { cx: 62, y: 112, w: 132, h: 5, bg: wood2 },
        { cx: 30, y: 117, w: 8, h: 12, bg: shade2, r: '40% 40% 8% 8%' },
      ]},
      { caption: 'Filling a tall, narrow wall segment between two window frames.', crop: 0, printCx: 0, surface: 32, shapes: [
        { cx: -105, y: 40, w: 76, h: 165, bg: glass2, r: '1px' },
        { cx: -105, y: 40, w: 80, h: 4, bg: dark2 },
        { cx: -105, y: 201, w: 80, h: 4, bg: dark2 },
        { cx: 105, y: 40, w: 76, h: 165, bg: glass2, r: '1px' },
        { cx: 105, y: 40, w: 80, h: 4, bg: dark2 },
        { cx: 105, y: 201, w: 80, h: 4, bg: dark2 },
      ]},
      { caption: 'Following the rise of a staircase wall \— the print tracks the stair height.', crop: 0, printCx: 30, surface: 62, shapes: [
        { cx: -95, y: 0, w: 40, h: 85, bg: linen3 },
        { cx: -115, y: 85, w: 40, h: 17, bg: linen3 },
        { cx: -75, y: 0, w: 40, h: 68, bg: linen3 },
        { cx: -55, y: 0, w: 40, h: 51, bg: linen3 },
        { cx: -35, y: 0, w: 40, h: 34, bg: linen3 },
        { cx: -15, y: 0, w: 40, h: 17, bg: linen3 },
        { cx: -60, y: 0, w: 150, h: 2, bg: dark2 },
      ]},
      { caption: 'Beside the front door \— a floor-to-ceiling welcome in a tall entry.', crop: 0, printCx: -68, surface: 28, shapes: [
        { cx: 62, y: 0, w: 96, h: 212, bg: wood2 },
        { cx: 38, y: 96, w: 3, h: 16, bg: dark2 },
        { cx: -68, y: 0, w: 130, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'Standing tall beside the bed \— not over it \— alongside a slim floor lamp.', crop: 0, printCx: -85, surface: 22, shapes: [
        { cx: 75, y: 10, w: 170, h: 62, bg: shade2, r: '4px 4px 0 0' },
        { cx: 75, y: 8, w: 164, h: 26, bg: '#D9D4C8' },
        { cx: 75, y: 28, w: 164, h: 22, bg: linen2, r: '4px' },
        { cx: -20, y: 0, w: 3, h: 155, bg: dark2 },
        { cx: -20, y: 155, w: 26, h: 18, bg: linen2, r: '50% 50% 8% 8%' },
      ]},
    ];
    const roomDefsGrandH = [
      { caption: 'Centred above an L-shaped sectional \— filling most of the wall it fronts.', crop: 0, printCx: 0, surface: 96, shapes: [
        { cx: -135, y: 0, w: 12, h: 64, bg: shade2, r: '9px 9px 0 0' },
        { cx: 0, y: 14, w: 258, h: 50, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 12, w: 258, h: 24, bg: linen2, r: '4px' },
        { cx: 100, y: 12, w: 58, h: 60, bg: shade2, r: '4px 4px 0 0' },
        { cx: -70, y: 34, w: 46, h: 20, bg: '#FFFFFF', r: '4px' },
        { cx: 0, y: 34, w: 46, h: 20, bg: linen3, r: '4px' },
      ]},
      { caption: 'Anchoring one end of a long dining table seating eight to ten.', crop: 0, printCx: 0, surface: 102, shapes: [
        { cx: 0, y: 74, w: 300, h: 4, bg: wood2 },
        { cx: -136, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: 136, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: -90, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: -30, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 30, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 90, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
      ]},
      { caption: 'Spanning most of a substantial mantel in a great room.', crop: 0, printCx: 0, surface: 122, shapes: [
        { cx: 0, y: 0, w: 200, h: 112, bg: linen3, r: '2px' },
        { cx: 0, y: 12, w: 90, h: 66, bg: dark2, r: '2px 2px 0 0' },
        { cx: 0, y: 112, w: 212, h: 5, bg: wood2 },
        { cx: -80, y: 117, w: 10, h: 14, bg: shade2, r: '40% 40% 8% 8%' },
      ]},
      { caption: 'The great room\’s main statement \— a single bench beneath a large open wall.', crop: 0, printCx: 0, surface: 92, shapes: [
        { cx: 0, y: 42, w: 165, h: 4, bg: wood2 },
        { cx: -70, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 70, y: 0, w: 4, h: 42, bg: dark2 },
      ]},
      { caption: 'Above a long bench in a spacious foyer or lobby.', crop: 0, printCx: 0, surface: 94, shapes: [
        { cx: 0, y: 42, w: 205, h: 4, bg: wood2 },
        { cx: -90, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 90, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 0, y: 0, w: 260, h: 3.5, bg: linen3, r: '50%' },
      ]},
    ];
    const roomDefsCollectorV = [
      { caption: 'Filling a double-height stairwell wall rising alongside two flights.', crop: 0, printCx: 40, surface: 85, shapes: [
        { cx: -110, y: 0, w: 44, h: 102, bg: linen3 },
        { cx: -88, y: 0, w: 44, h: 85, bg: linen3 },
        { cx: -66, y: 0, w: 44, h: 68, bg: linen3 },
        { cx: -44, y: 0, w: 44, h: 51, bg: linen3 },
        { cx: -22, y: 0, w: 44, h: 34, bg: linen3 },
        { cx: 0, y: 0, w: 44, h: 17, bg: linen3 },
        { cx: -55, y: 0, w: 180, h: 2, bg: dark2 },
      ]},
      { caption: 'Floor to near-ceiling in a high-ceilinged entry foyer.', crop: 0, printCx: 0, surface: 20, shapes: [
        { cx: -110, y: 0, w: 12, h: 12, bg: dark2 },
        { cx: -110, y: 9, w: 30, h: 40, bg: leaf2, r: '50% 50% 42% 42%' },
        { cx: 0, y: 0, w: 240, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'Filling a tall wall segment between two sections of library shelving.', crop: 0, printCx: 0, surface: 25, shapes: [
        { cx: -120, y: 0, w: 90, h: 230, bg: wood2 },
        { cx: -120, y: 57, w: 90, h: 2, bg: dark2 },
        { cx: -120, y: 114, w: 90, h: 2, bg: dark2 },
        { cx: -120, y: 171, w: 90, h: 2, bg: dark2 },
        { cx: 120, y: 0, w: 90, h: 230, bg: wood2 },
        { cx: 120, y: 57, w: 90, h: 2, bg: dark2 },
        { cx: 120, y: 114, w: 90, h: 2, bg: dark2 },
        { cx: 120, y: 171, w: 90, h: 2, bg: dark2 },
      ]},
      { caption: 'Beside a fireplace in a great room with high ceilings.', crop: 0, printCx: -85, surface: 20, shapes: [
        { cx: 80, y: 0, w: 130, h: 120, bg: linen3, r: '2px' },
        { cx: 80, y: 14, w: 60, h: 68, bg: dark2, r: '2px 2px 0 0' },
        { cx: 80, y: 120, w: 142, h: 5, bg: wood2 },
      ]},
      { caption: 'Hung alone in a tall, wide corridor \— the single gallery-style piece.', crop: 0, printCx: 0, surface: 25, shapes: [
        { cx: 0, y: 0, w: 260, h: 3.5, bg: linen3 },
        { cx: 0, y: 3.5, w: 260, h: 1, bg: dark2 },
      ]},
    ];
    const roomDefsCollectorH = [
      { caption: 'Spanning most of a large, open living-room wall with minimal furniture below.', crop: 0, printCx: 0, surface: 86, shapes: [
        { cx: 0, y: 42, w: 185, h: 4, bg: wood2 },
        { cx: -80, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 80, y: 0, w: 4, h: 42, bg: dark2 },
      ]},
      { caption: 'Above a communal table seating ten to twelve \— matching its length.', crop: 0, printCx: 0, surface: 100, shapes: [
        { cx: 0, y: 74, w: 360, h: 4, bg: wood2 },
        { cx: -165, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: 165, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: -120, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: -60, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 60, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 120, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
      ]},
      { caption: 'On a wide hotel-reception wall, a long bench beneath.', crop: 0, printCx: 0, surface: 88, shapes: [
        { cx: 0, y: 42, w: 245, h: 4, bg: wood2 },
        { cx: -110, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 110, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 0, y: 0, w: 320, h: 3.5, bg: linen3, r: '50%' },
      ]},
      { caption: 'Spanning nearly the full length of an extra-long buffet.', crop: 0, printCx: 0, surface: 90, shapes: [
        { cx: -90, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 90, y: 0, w: 4, h: 8, bg: dark2 },
        { cx: 0, y: 8, w: 200, h: 58, bg: wood2, r: '3px' },
        { cx: -72, y: 66, w: 5, h: 20, bg: dark2 },
        { cx: 72, y: 66, w: 7, h: 8, bg: dark2 },
        { cx: 72, y: 71, w: 16, h: 13, bg: leaf2, r: '50%' },
      ]},
      { caption: 'On the main wall of an open-plan space \— one work unifying living and dining zones.', crop: 0, printCx: 0, surface: 86, shapes: [
        { cx: -120, y: 0, w: 8, h: 10, bg: dark2 },
        { cx: -120, y: 8, w: 56, h: 24, bg: shade2, r: '4px' },
        { cx: -120, y: 30, w: 56, h: 38, bg: shade2, r: '9px 9px 0 0' },
        { cx: 120, y: 74, w: 130, h: 4, bg: wood2 },
        { cx: 90, y: 0, w: 4, h: 74, bg: dark2 },
        { cx: 150, y: 0, w: 4, h: 74, bg: dark2 },
      ]},
    ];
    const roomDefsStatementV = [
      { caption: 'Nearly floor to ceiling in a grand entry with soaring ceilings.', crop: 0, printCx: 0, surface: 15, shapes: [
        { cx: -130, y: 0, w: 12, h: 12, bg: dark2 },
        { cx: -130, y: 9, w: 32, h: 44, bg: leaf2, r: '50% 50% 42% 42%' },
        { cx: 0, y: 0, w: 280, h: 4, bg: linen3, r: '50%' },
      ]},
      { caption: 'On a double-height great-room wall \— real vertical drama above the seating.', crop: 0, printCx: 0, surface: 15, shapes: [
        { cx: 0, y: 0, w: 300, h: 1.5, bg: dark2 },
      ], front: [
        { cx: 0, y: 0, w: 8, h: 10, bg: dark2 },
        { cx: 0, y: 8, w: 62, h: 26, bg: shade2, r: '4px' },
        { cx: 0, y: 32, w: 62, h: 40, bg: shade2, r: '9px 9px 0 0' },
      ]},
      { caption: 'Following a tall staircase\’s complete rise.', crop: 0, printCx: 45, surface: 70, shapes: [
        { cx: -130, y: 0, w: 48, h: 119, bg: linen3 },
        { cx: -106, y: 0, w: 48, h: 102, bg: linen3 },
        { cx: -82, y: 0, w: 48, h: 85, bg: linen3 },
        { cx: -58, y: 0, w: 48, h: 68, bg: linen3 },
        { cx: -34, y: 0, w: 48, h: 51, bg: linen3 },
        { cx: -10, y: 0, w: 48, h: 34, bg: linen3 },
        { cx: 14, y: 0, w: 48, h: 17, bg: linen3 },
        { cx: -58, y: 0, w: 200, h: 2, bg: dark2 },
      ]},
      { caption: 'On a tall entrance wall in a museum or gallery setting.', crop: 0, printCx: 0, surface: 20, shapes: [
        { cx: 0, y: 0, w: 190, h: 40, bg: linen3 },
        { cx: 0, y: 40, w: 190, h: 2, bg: dark2 },
      ]},
      { caption: 'Spanning the full height of a hotel or building atrium.', crop: 0, printCx: 0, surface: 12, shapes: [
        { cx: -125, y: 0, w: 24, h: 20, bg: dark2 },
        { cx: -125, y: 18, w: 44, h: 56, bg: leaf2, r: '50% 50% 42% 42%' },
        { cx: 125, y: 0, w: 24, h: 20, bg: dark2 },
        { cx: 125, y: 18, w: 44, h: 56, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
    ];
    const roomDefsStatementH = [
      { caption: 'A full-wall panorama \— just a low bench beneath the entire span.', crop: 0, printCx: 0, surface: 72, shapes: [
        { cx: 0, y: 42, w: 190, h: 4, bg: wood2 },
        { cx: -82, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 82, y: 0, w: 4, h: 42, bg: dark2 },
      ]},
      { caption: 'Above a grand communal table seating twelve or more.', crop: 0, printCx: 0, surface: 96, shapes: [
        { cx: 0, y: 74, w: 400, h: 4, bg: wood2 },
        { cx: -185, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: 185, y: 0, w: 5, h: 74, bg: dark2 },
        { cx: -140, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: -70, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 0, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 70, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
        { cx: 140, y: 45, w: 26, h: 31, bg: shade2, r: '4px 4px 0 0' },
      ]},
      { caption: 'The primary wall greeting visitors as they enter a large gallery space.', crop: 0, printCx: 0, surface: 78, shapes: [
        { cx: 0, y: 0, w: 340, h: 2, bg: dark2 },
      ]},
      { caption: 'Spanning the full width of a loft\’s main wall.', crop: 0, printCx: 0, surface: 72, shapes: [
        { cx: -80, y: 0, w: 150, h: 44, bg: wood2, r: '2px' },
        { cx: -80, y: 22, w: 150, h: 1.4, bg: dark2 },
        { cx: 120, y: 0, w: 20, h: 18, bg: dark2 },
        { cx: 120, y: 16, w: 38, h: 50, bg: leaf2, r: '50% 50% 42% 42%' },
      ]},
      { caption: 'On the feature wall of a lobby or atrium, a long bench below.', crop: 0, printCx: 0, surface: 82, shapes: [
        { cx: 0, y: 42, w: 280, h: 4, bg: wood2 },
        { cx: -125, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 125, y: 0, w: 4, h: 42, bg: dark2 },
        { cx: 0, y: 0, w: 360, h: 3.5, bg: linen3, r: '50%' },
      ]},
    ];
    const roomDefsBySize = { 0: roomDefsMini, 1: roomDefsSmall, 2: roomDefsMedium, 3: roomDefsLarge, 4: roomDefsXLarge, 5: roomDefsGallery, 6: roomDefsGrandV, 7: roomDefsCollectorV, 8: roomDefsStatementV };
    const roomDefsBySizeH = { 0: roomDefsMiniH, 1: roomDefsSmallH, 2: roomDefsMediumH, 3: roomDefsLargeH, 4: roomDefsXLargeH, 5: roomDefsGalleryH, 6: roomDefsGrandH, 7: roomDefsCollectorH, 8: roomDefsStatementH };
    
    ROOM_V = roomDefsBySize;
    ROOM_H = roomDefsBySizeH;
  })();

  function roomScenePanel(g, sizeIdx, orient, frameCol, roomW) {
    var defs = (orient === 1 ? ROOM_H : ROOM_V)[sizeIdx] || [];
    if (!defs.length) return { html: null, scenes: [], len: 0 };
    var scFrameBg = GUIDE_FCOLS[frameCol].bg;
    var scFrameEdge = frameCol === 1 ? '1px solid #D9D4C2' : 'none';
    function ori2(a, b) { return orient === 1 ? [b, a] : [a, b]; }
    var roomFramed = g.fw != null;
    var rf = ori2(roomFramed ? g.fw : g.pw, roomFramed ? g.fh : g.ph);
    var rfw = rf[0], rfh = rf[1];
    var rm = roomFramed ? ori2(g.mw || 0, g.mh || 0) : ori2(g.iw, g.ih);
    var rmw = rm[0], rmh = rm[1];
    var art = fgPrintImg();
    var artNode = art ? '<img src="' + esc(art) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
    var sceneArr = defs.map(function (d) {
      var wallTop = d.surface + rfh + 22, visH = wallTop - d.crop;
      var all = d.shapes.concat(d.front || []);
      var wcm2 = Math.max.apply(null, all.map(function (sh) { return Math.abs(sh.cx) + sh.w / 2; })) * 2 + 16;
      var usableW = Math.max(150, (roomW || 260) - 30);
      var rsc = Math.min(usableW / wcm2, 240 / visH);
      var pxr = function (v) { return Math.round(v * rsc * 10) / 10 + 'px'; };
      function shp(sh) {
        var bg = sh.bg === '__FRAME__' ? scFrameBg : sh.bg;
        return '<div style="position:absolute;left:calc(50% + ' + Math.round((sh.cx - sh.w / 2) * rsc) + 'px);bottom:' + Math.round(30 + (sh.y - d.crop) * rsc) + 'px;width:' + pxr(sh.w) + ';height:' + pxr(sh.h) + ';background:' + bg + ';border-radius:' + (sh.r || '0') + ';"></div>';
      }
      var printH = '<div style="position:absolute;left:calc(50% + ' + Math.round((d.printCx - rfw / 2) * rsc) + 'px);bottom:' + Math.round(30 + (d.surface - d.crop) * rsc) + 'px;width:' + pxr(rfw) + ';height:' + pxr(rfh) + ';background:' + (roomFramed ? scFrameBg : '#FFFFFF') + ';border:' + (roomFramed ? scFrameEdge : '1px solid #D9D4C8') + ';padding:' + (roomFramed ? pxr(g.frW || 2) : '0px') + ';box-shadow:0 8px 14px -8px rgba(17,17,17,0.45);box-sizing:border-box;">'
        + '<div style="width:100%;height:100%;background:#fff;display:flex;align-items:center;justify-content:center;"><div style="width:' + pxr(rmw) + ';height:' + pxr(rmh) + ';background:#fff;box-shadow:inset 0 0 0 1px #E1DED8;padding:' + pxr(g.sig || 0.8) + ';box-sizing:border-box;"><div style="width:100%;height:100%;background:#E7E2D8;overflow:hidden;">' + artNode + '</div></div></div></div>';
      return '<div style="flex:0 0 100%;width:100%;height:100%;position:relative;background:#F1EFEB;scroll-snap-align:start;overflow:hidden;">'
        + '<div style="position:absolute;top:14px;left:14px;right:46px;font-size:11px;line-height:1.55;color:#8A8680;z-index:2;">' + esc(d.caption) + '</div>'
        + d.shapes.map(shp).join('') + printH + (d.front || []).map(shp).join('') + '</div>';
    });
    var scenes = sceneArr.join('');
    var arrowBtn = function (act, icon) {
      return '<button type="button" data-act="' + act + '" style="width:30px;height:30px;border-radius:50%;border:1px solid #E3E1DD;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">' + icon + '</button>';
    };
    var arrows = defs.length > 1
      ? '<div class="fg-room-arrows" style="position:absolute;right:10px;bottom:12px;display:flex;gap:6px;z-index:3;">' + arrowBtn('room-prev', ICON.arrowL) + arrowBtn('room-next', ICON.arrowR) + '</div>'
      : '';
    var dots = defs.length > 1
      ? '<div class="fg-room-dots" style="position:absolute;right:10px;bottom:12px;display:none;gap:6px;z-index:3;">' + defs.map(function (_, i) {
          return '<button type="button" data-act="room-jump" data-i="' + i + '" style="width:24px;height:24px;border-radius:50%;border:1px solid #111;background:' + (i === 0 ? '#111' : '#fff') + ';color:' + (i === 0 ? '#fff' : '#111') + ';font-size:11px;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">' + (i + 1) + '</button>';
        }).join('') + '</div>'
      : '';
    return { html: '<div style="position:relative;width:100%;height:100%;overflow:hidden;"><div class="fg-room-scroll" style="display:flex;width:100%;height:100%;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;">' + scenes + '</div>' + arrows + dots + '</div>', scenes: sceneArr, len: defs.length };
  }

  function buildSizeGuide() {
    var st = { orient: 0, sizeIdx: 4, framed: true, frameCol: 2, unit: 'cm', idx: 0, panels: [], menuOpen: false };
    var r1 = function (v) { return Math.round(v * 10) / 10; };
    var toIn = function (v) { return r1(v / 2.54); };
    function ori(w, h) { return st.orient === 1 ? [h, w] : [w, h]; }
    function cmIn(w, h) { return st.unit === 'cm' ? r1(w) + ' × ' + r1(h) + ' cm' : toIn(w) + ' × ' + toIn(h) + ' in'; }
    function specRows(rows) {
      return rows.map(function (r) {
        return '<div style="display:grid;grid-template-columns:1fr auto;gap:20px;align-items:baseline;padding:13px 0;border-top:1px solid #ECEAE6;">'
          + '<span style="font-size:13px;color:#8A8680;">' + esc(r[0]) + '</span>'
          + '<span style="font-size:13.5px;font-weight:600;color:#111;text-align:right;">' + esc(r[1]) + '</span></div>';
      }).join('');
    }
    function ctlLbl(t) { return '<div style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:#111;margin-bottom:12px;">' + t + '</div>'; }

    var modal = Modal(function () {
      var g = GUIDE_SIZES[st.sizeIdx];
      var framedOn = st.framed !== false && g.fw != null;
      var pO = ori(g.pw, g.ph), gw = pO[0], gh = pO[1];
      var oO = framedOn ? ori(g.fw, g.fh) : [gw, gh], ow = oO[0], oh = oO[1];
      var iO = ori(g.iw, g.ih);
      var sc = Math.min(280 / Math.max(180, oh + 70), 145 / Math.max(100, ow));
      var figH = 170 * sc;
      var px = function (v) { return Math.round(v * sc * 10) / 10 + 'px'; };
      var orientLabel = GUIDE_ORI[st.orient];

      // to-scale silhouette
      var art = fgPrintImg();
      var artNode = art ? '<img src="' + esc(art) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
      var frameBg = GUIDE_FCOLS[st.frameCol].bg, frameEdge = st.frameCol === 1 ? '1px solid #D9D4C2' : 'none';
      var box;
      if (framedOn) {
        var mO = ori(g.mw, g.mh);
        box = '<div style="box-sizing:border-box;width:' + px(ow) + ';height:' + px(oh) + ';background:' + frameBg + ';border:' + frameEdge + ';padding:' + px(g.frW || 0) + ';box-shadow:0 14px 26px -16px rgba(17,17,17,0.45);">'
          + '<div style="box-sizing:border-box;width:100%;height:100%;background:#fff;display:flex;align-items:center;justify-content:center;">'
          + '<div style="box-sizing:border-box;width:' + px(mO[0]) + ';height:' + px(mO[1]) + ';background:#fff;box-shadow:inset 0 0 0 1px #E1DED8, inset 0 1px 3px rgba(17,17,17,0.16);padding:' + px(g.sig || 0) + ';">'
          + '<div style="width:100%;height:100%;background:#E7E2D8;overflow:hidden;">' + artNode + '</div></div></div></div>';
      } else {
        box = '<div style="box-sizing:border-box;width:' + px(ow) + ';height:' + px(oh) + ';background:#fff;border:1px solid #D9D4C8;box-shadow:0 10px 20px -14px rgba(17,17,17,0.35);display:flex;align-items:center;justify-content:center;">'
          + '<div style="box-sizing:content-box;padding:' + px(g.sig || 0) + ';"><div style="width:' + px(iO[0]) + ';height:' + px(iO[1]) + ';background:#E7E2D8;overflow:hidden;">' + artNode + '</div></div></div>';
      }
      var hpx = Math.round(figH * 0.14), bw = Math.round(figH * 0.28), bh = Math.round(figH * 0.84);
      var pbpx = Math.round(Math.max(10, (150 - oh / 2) * sc)) + 'px';
      var toScale = '<div style="position:relative;background:#F1EFEB;height:100%;min-height:300px;display:flex;align-items:flex-end;justify-content:center;gap:44px;padding:24px 24px 48px;overflow:hidden;">'
        + '<div style="position:absolute;left:24px;right:24px;bottom:48px;height:1px;background:#D9D4C8;"></div>'
        + '<div style="display:flex;flex-direction:column;align-items:center;gap:2px;z-index:1;"><div style="width:' + hpx + 'px;height:' + hpx + 'px;border-radius:50%;background:#D9D4C8;"></div><div style="width:' + bw + 'px;height:' + bh + 'px;background:#D9D4C8;border-radius:46% 46% 10% 10% / 18% 18% 3% 3%;"></div></div>'
        + '<div style="position:relative;z-index:1;margin-bottom:' + pbpx + ';"><div style="position:absolute;bottom:100%;left:0;right:0;text-align:center;font-size:10px;letter-spacing:0.08em;color:#A38B5F;padding-bottom:6px;white-space:nowrap;">' + r1(ow) + ' cm</div>' + box
        + '<div style="position:absolute;left:100%;top:0;bottom:0;display:flex;align-items:center;padding-left:6px;font-size:10px;letter-spacing:0.08em;color:#A38B5F;writing-mode:vertical-rl;white-space:nowrap;">' + r1(oh) + ' cm</div></div></div>';

      var roomPanel = roomScenePanel(g, st.sizeIdx, st.orient, st.frameCol, st.roomW);
      var roomInner = roomPanel.html || compositePanel('room', g.name, orientLabel);
      st.panels = [
        { inner: toScale, label: 'To scale · vs 170 cm' },
        { inner: roomInner, label: 'Styling ideas' }
      ];

      // Mobile (size guide): ONE continuous swipe across the To-scale figure plus
      // every room scene, with a single "N / total" counter (To scale counts as 1)
      // and NO dots. Desktop keeps the two-panel grid.
      var sgSceneItems = '<div style="flex:0 0 100%;width:100%;height:100%;position:relative;scroll-snap-align:start;overflow:hidden;">' + toScale + '</div>' + roomPanel.scenes.join('');
      var sgTotal = 1 + roomPanel.len;
      var sgArrow = function (act, icon) { return '<button type="button" data-act="' + act + '" style="width:30px;height:30px;border-radius:50%;border:1px solid #E3E1DD;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;">' + icon + '</button>'; };
      var sgCounter = roomPanel.len > 0
        ? '<div class="sg-counter" style="position:absolute;right:12px;bottom:12px;display:flex;align-items:center;gap:8px;z-index:3;">' + sgArrow('sg-prev', ICON.arrowL) + '<span class="sg-count" style="min-width:40px;text-align:center;font-size:12px;letter-spacing:0.06em;color:#111;">1 / ' + sgTotal + '</span>' + sgArrow('sg-next', ICON.arrowR) + '</div>'
        : '';
      var sgMobile = '<div class="fg-imgs-mobile sg-mobile"><div class="sg-scroller" style="position:relative;width:100%;height:380px;overflow:hidden;background:#F1EFEB;">'
        + '<div class="fg-room-scroll sg-scroll" style="display:flex;width:100%;height:100%;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;">' + sgSceneItems + '</div>'
        + '<span class="fg-panel-label sg-label">To scale &middot; vs 170 cm</span>'
        + sgCounter
        + '</div></div>';
      var sgDesktop = '<div class="fg-imgs-desktop" style="grid-template-columns:1.15fr 1fr;">' + panelBox(toScale, 'To scale · vs 170 cm') + panelBox(roomInner, 'Styling ideas') + '</div>';
      var sgVisuals = sgDesktop + sgMobile;

      // controls
      // v2 controls: Print size dropdown · Framing (colour chips + Unframed
      // hatch, one control) · Orientation — matching the updated handoff.
      var canFrame = g.fw != null;
      var orientBtns = GUIDE_ORI.map(function (o, i) { return '<button type="button" data-act="orient" data-i="' + i + '" style="flex:1;box-sizing:border-box;height:56px;padding:0;background:#fff;border:1px solid ' + (i === st.orient ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:13px;font-weight:' + (i === st.orient ? 600 : 400) + ';color:#111;">' + o + '</button>'; }).join('');
      function chipBtn(act, i, swatch, label, active, enabled) {
        return '<button type="button" ' + (enabled ? 'data-act="' + act + '" data-i="' + i + '"' : 'disabled') + ' style="flex:1 1 0;min-width:0;box-sizing:border-box;height:56px;box-sizing:border-box;display:grid;grid-template-rows:12px auto;align-content:center;justify-items:start;row-gap:6px;padding:10px 14px;overflow:hidden;background:#fff;border:1px solid ' + (active ? '#111' : '#E3E1DD') + ';cursor:' + (enabled ? 'pointer' : 'default') + ';font-size:12px;font-weight:' + (active ? 600 : 400) + ';color:' + (enabled ? '#111' : '#C4BFB6') + ';text-align:left;"><span style="display:block;width:52px;max-width:100%;height:11px;background:' + swatch + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.14);"></span>' + label + '</button>';
      }
      var frameBtns = GUIDE_FCOLS.map(function (fc, i) {
        return chipBtn('framecol', i, fc.bg, fc.label, framedOn && i === st.frameCol, canFrame);
      }).join('') + chipBtn('framed-off', 0, 'repeating-linear-gradient(45deg, #FFFFFF 0, #FFFFFF 4px, #ECEAE6 4px, #ECEAE6 5px)', 'Unframed', !framedOn, true);
      var sizeMenu = GUIDE_SIZES.map(function (s, i) { return '<button type="button" data-act="size" data-i="' + i + '" style="width:100%;display:flex;justify-content:space-between;align-items:center;padding:12px 16px;background:' + (i === st.sizeIdx ? '#F7F6F2' : '#fff') + ';border:none;border-top:' + (i === 0 ? 'none' : '1px solid #ECEAE6') + ';cursor:pointer;"><span style="font-size:14px;font-weight:' + (i === st.sizeIdx ? 600 : 400) + ';color:#111;">' + esc(s.name) + '</span><span style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#8A8680;">' + esc(s.code || '—') + '</span></button>'; }).join('');
      var controls = '<div class="fg-guide-controls" style="display:grid;grid-template-columns:1fr 1.7fr 1fr;gap:20px;margin:24px 0 26px;">'
        + '<div>' + ctlLbl('Print size') + '<div style="position:relative;"><button type="button" data-act="menu" style="width:100%;box-sizing:border-box;height:56px;display:flex;justify-content:space-between;align-items:center;padding:0 18px;background:#fff;border:1px solid #111;cursor:pointer;"><span style="font-size:14px;font-weight:600;">' + esc(g.name) + '</span><span style="font-size:10px;color:#8A8680;">' + (st.menuOpen ? '▲' : '▼') + '</span></button>'
        + '<div style="display:' + (st.menuOpen ? 'block' : 'none') + ';position:absolute;top:calc(100% + 6px);left:0;right:0;background:#fff;border:1px solid #111;box-shadow:0 16px 32px -16px rgba(17,17,17,0.25);z-index:20;max-height:300px;overflow-y:auto;">' + sizeMenu + '</div></div></div>'
        + '<div>' + ctlLbl('Framing') + '<div style="display:flex;gap:8px;">' + frameBtns + '</div></div>'
        + '<div>' + ctlLbl('Orientation') + '<div style="display:flex;gap:8px;">' + orientBtns + '</div></div>'
        + '</div>';

      // specs
      var giO = ori(g.iw, g.ih);
      var leftRows = [['Paper size', cmIn(gw, gh)], ['Image size', cmIn(giO[0], giO[1])], ['Paper', 'Ilford Fine Art Smooth · 200 gsm'], ['Print method', 'Archival pigment (giclée)']];
      var rightHead, rightRows;
      if (g.fw == null) {
        rightHead = 'Framing'; rightRows = [['Shadow box framing', 'Not available at this size'], ['Delivery', 'Ships rolled in a museum-grade tube']];
      } else {
        var mO2 = ori(g.mw, g.mh), fO = ori(g.fw, g.fh);
        rightHead = 'Framed · Premium Shadow Box';
        rightRows = [['Frame size (W × H × D)', st.unit === 'cm' ? r1(fO[0]) + ' × ' + r1(fO[1]) + ' × ' + r1(g.fd) + ' cm' : toIn(fO[0]) + ' × ' + toIn(fO[1]) + ' × ' + toIn(g.fd) + ' in'], ['Image size', cmIn(giO[0], giO[1])], ['Mat opening', cmIn(mO2[0], mO2[1])], ['Frame face width', st.unit === 'cm' ? r1(g.frW) + ' cm' : toIn(g.frW) + ' in']];
      }
      var specHead = function (t) { return '<div style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:#8A8680;margin-bottom:2px;">' + esc(t) + '</div>'; };
      var unitToggle = '<div style="display:flex;gap:8px;">' + ['cm', 'in'].map(function (u) {
        var on = st.unit === u;
        return '<button type="button" data-act="unit" data-u="' + u + '" style="box-sizing:border-box;height:40px;padding:0 20px;background:#fff;border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:13px;letter-spacing:0.14em;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#111' : '#8A8680') + ';">' + u.toUpperCase() + '</button>';
      }).join('') + '</div>';

      return '<div class="fg-head fg-head--pad"><div class="fg-head-row"><div>'
        + '<div class="eyebrow fg-eyebrow-ico">' + ICON.ruler + ' Size guide</div>'
        + '<h3 class="serif fg-title">Limited Edition Prints</h3></div>'
        + '<button type="button" class="fg-close" data-fg-close aria-label="Close">' + ICON.close + '</button></div></div>'
        + '<div class="fg-body">'
        + controls
        + '<div class="fg-guide-visuals">' + sgVisuals + '</div>'
        + '<div style="display:flex;justify-content:space-between;align-items:baseline;margin:26px 0 4px;"><div><span class="serif" style="font-size:26px;">' + esc(g.name) + '</span><span style="font-size:13px;color:#8A8680;margin-left:12px;">' + esc(g.code || '—') + ' · ' + esc(orientLabel) + '</span></div>' + unitToggle + '</div>'
        + '<p style="font-size:14px;line-height:1.7;color:#55524D;margin:0 0 22px;max-width:70ch;">' + esc(g.use) + '</p>'
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:28px 56px;">'
        + '<div>' + specHead('Unframed print') + specRows(leftRows) + '</div>'
        + '<div>' + specHead(rightHead) + specRows(rightRows) + '</div>'
        + '</div>'
        + (document.querySelector('.le-template')
          ? '<p style="font-size:13px;line-height:1.7;color:#8A8680;margin:22px 0 0;max-width:68ch;">Limited edition prints are framed exclusively in our premium shadow box. Frame figures are the outer size; the third number is depth — see the <button type="button" data-fo-framing-guide style="background:none;border:none;padding:0;font:inherit;color:#111;text-decoration:underline;text-underline-offset:3px;cursor:pointer;">Framing guide</button>.</p>'
          : '')
        + '<div style="margin-top:34px;">'
        + '<div class="serif" style="font-size:24px;margin-bottom:8px;">Standard size equivalents</div>'
        + '<p style="font-size:13.5px;line-height:1.7;color:#55524D;margin:0 0 18px;max-width:74ch;">New to art prints? Each of our size names matches a familiar ISO paper format — the same A- and B-series numbers used across Europe for paper and off-the-shelf frames. If you already own a frame or know a size, use this to find its match.</p>'
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:0 56px;">'
        + GUIDE_SIZES.map(function (s) {
            return '<div style="display:grid;grid-template-columns:auto 1fr auto;gap:14px;align-items:baseline;padding:12px 0;border-bottom:1px solid #ECEAE6;">'
              + '<span style="font-size:14px;font-weight:600;color:#111;">' + esc(s.name) + '</span>'
              + '<span style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:' + (s.code ? '#8A8680' : '#B7B2AA') + ';">' + (s.code ? esc(s.code) : '') + '</span>'
              + '<span style="font-size:13px;color:#55524D;white-space:nowrap;">' + r1(s.pw) + ' × ' + r1(s.ph) + ' cm</span>'
              + '</div>';
          }).join('')
        + '</div></div>'
        + '</div>'
        + '<div class="fg-footer"><div class="fg-foot-meta"><span>All works made to order · printed on Ilford fine art paper</span></div>'
        + '<button type="button" class="fg-cta" data-fg-close>Close</button></div>';
    });

    modal._bind = function (panel) {
      // Bind the delegated click handler ONCE — panel persists across repaints,
      // so re-adding it every paint stacks listeners and freezes the modal.
      if (!panel.__sgClick) {
        panel.__sgClick = true;
        panel.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('[data-act]');
          if (!b) { if (st.menuOpen) { st.menuOpen = false; modal.paint(); } return; }
          var act = b.getAttribute('data-act'), i = +b.getAttribute('data-i');
          if (act === 'orient') st.orient = i;
          else if (act === 'framed') st.framed = i === 0;
          else if (act === 'framed-off') st.framed = false;
          else if (act === 'framecol') { st.frameCol = i; st.framed = true; }
          else if (act === 'size') { st.sizeIdx = i; st.menuOpen = false; st.idx = 0; }
          else if (act === 'menu') { st.menuOpen = !st.menuOpen; }
          else if (act === 'unit') st.unit = b.getAttribute('data-u');
          else if (act === 'room-jump') {
            var wrapJ = b.closest('.fg-panelbox') || panel;
            var scJ = wrapJ.querySelector('.fg-room-scroll');
            if (scJ) scJ.scrollTo({ left: i * scJ.clientWidth, behavior: 'smooth' });
            return;
          }
          else if (act === 'room-prev' || act === 'room-next') {
            // Scroll the room carousel INSIDE the clicked arrow's own panel —
            // the modal renders the panels twice (desktop grid + mobile swipe),
            // and querying the first match scrolled the hidden desktop copy,
            // which is why the arrows appeared dead on mobile.
            var wrap = b.closest('.fg-panelbox') || panel;
            var scEl = wrap.querySelector('.fg-room-scroll');
            if (scEl) { var dir = act === 'room-next' ? 1 : -1, mx = scEl.scrollWidth - scEl.clientWidth, tgt = scEl.scrollLeft + dir * scEl.clientWidth; if (dir > 0 && scEl.scrollLeft >= mx - 8) tgt = 0; if (dir < 0 && scEl.scrollLeft <= 8) tgt = mx; scEl.scrollTo({ left: tgt, behavior: 'smooth' }); }
            return;
          }
          else if (act === 'sg-prev' || act === 'sg-next') {
            // Size-guide combined mobile scroller (To scale + room scenes): step
            // one scene, wrapping at the ends.
            var sgEl = panel.querySelector('.sg-scroll');
            if (sgEl) { var sd = act === 'sg-next' ? 1 : -1, sgmx = sgEl.scrollWidth - sgEl.clientWidth, sgt = sgEl.scrollLeft + sd * sgEl.clientWidth; if (sd > 0 && sgEl.scrollLeft >= sgmx - 8) sgt = 0; if (sd < 0 && sgEl.scrollLeft <= 8) sgt = sgmx; sgEl.scrollTo({ left: sgt, behavior: 'smooth' }); }
            return;
          }
          else return;
          modal.paint();
        });
      }
      bindSwipe(panel, st, function (i) { st.idx = i; modal.paint(); });
      applyWarps(panel);
      // Keep the numbered scene dots in sync with swipe position (mobile).
      Array.prototype.forEach.call(panel.querySelectorAll('.fg-room-scroll'), function (sc) {
        if (sc.__dotSync) return;
        sc.__dotSync = true;
        sc.addEventListener('scroll', function () {
          var idx = Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth));
          var dotsEl = sc.parentNode.querySelector('.fg-room-dots');
          if (!dotsEl) return;
          Array.prototype.forEach.call(dotsEl.children, function (dbtn, j) {
            dbtn.style.background = j === idx ? '#111' : '#fff';
            dbtn.style.color = j === idx ? '#fff' : '#111';
          });
        }, { passive: true });
      });
      // Size-guide combined mobile scroller: keep the "N / total" counter and the
      // bottom-left label ("To scale …" for the first scene, "Styling ideas" after)
      // in sync with the swipe/scroll position.
      Array.prototype.forEach.call(panel.querySelectorAll('.sg-scroll'), function (sc) {
        if (sc.__sgSync) return;
        sc.__sgSync = true;
        sc.addEventListener('scroll', function () {
          var idx = Math.round(sc.scrollLeft / Math.max(1, sc.clientWidth));
          var total = sc.children.length;
          var wrap = sc.parentNode;
          var cnt = wrap.querySelector('.sg-count'); if (cnt) cnt.textContent = (idx + 1) + ' / ' + total;
          var lbl = wrap.querySelector('.sg-label'); if (lbl) lbl.textContent = idx === 0 ? 'To scale · vs 170 cm' : 'Styling ideas';
        }, { passive: true });
      });
      // Measure the VISIBLE room-scene container so scenes scale to its real width
      // (desktop grid + mobile scroller both carry .fg-room-scroll; the hidden one
      // reports width 0). Repaint once when it first differs from the default.
      var scrollEls = panel.querySelectorAll('.fg-room-scroll'), rsEl = null;
      for (var si = 0; si < scrollEls.length; si++) { if (scrollEls[si].clientWidth > 0) { rsEl = scrollEls[si]; break; } }
      if (rsEl) { var w = rsEl.clientWidth; if (w && Math.abs((st.roomW || 0) - w) > 4) { st.roomW = w; modal.paint(); } }
    };

    return {
      open: function () {
        var cur = readCurrentSize();
        st.orient = cur.orient === 'horizontal' ? 1 : 0;
        var idx = -1;
        for (var i = 0; i < GUIDE_SIZES.length; i++) { if (GUIDE_SIZES[i].code && GUIDE_SIZES[i].code === cur.code) { idx = i; break; } }
        if (idx < 0) for (var j = 0; j < GUIDE_SIZES.length; j++) { if (GUIDE_SIZES[j].name.toLowerCase() === String(cur.name || '').toLowerCase()) { idx = j; break; } }
        if (idx >= 0) st.sizeIdx = idx;
        st.idx = 0; st.menuOpen = false;
        modal.open();
      }
    };
  }

  /* --------- LE Framing & Paper Guide (Premium Shadow Box) ----------
     Port of the Claude Design handoff: two tabs (Framing / Paper), a
     true-scale cross-section, an oversized corner detail with real oak
     texture, per-size profile/materials tables, and an exploded
     construction strip. LE product page only — the default page keeps
     the legacy guide (it also sells Classic frames). Oak textures come
     from theme assets via the [data-fg-tex] element's data attributes. */
  var FGLE_SIZES = [
    { name: 'Mini',    code: 'A4', face: 2, depth: 3,   fw: 24,   fh: 33,  mw: 16.3, mh: 22.4,  kg: 1.2 },
    { name: 'Small',   code: 'A3', face: 2, depth: 3,   fw: 33,   fh: 45.4, mw: 22.8, mh: 31.4, kg: 2 },
    { name: 'Medium',  code: 'A2', face: 3, depth: 4.5, fw: 46,   fh: 63.5, mw: 31.4, mh: 43.6, kg: 3.5 },
    { name: 'Large',   code: 'A1', face: 3, depth: 4.5, fw: 63.5, fh: 88,  mw: 49.9, mh: 69.7,  kg: 5.5 },
    { name: 'X-Large', code: 'B1', face: 3, depth: 4.5, fw: 75,   fh: 105, mw: 59.4, mh: 82.8,  kg: 7.5 },
    { name: 'Gallery', code: 'A0', face: 3, depth: 4.5, fw: 89,   fh: 124, mw: 70.5, mh: 98.3,  kg: 10 },
    { name: 'Grand',   code: '',   face: 3, depth: 4.5, fw: 106,  fh: 157, mw: 84.9, mh: 118.5, kg: 13 }
  ];
  var FGLE_FINS = [
    { label: 'Natural', bg: '#BE9558', edge: 'none', oak: true },
    { label: 'White', bg: '#F6F4F0', edge: '1px solid #D9D4C2', oak: false },
    { label: 'Black', bg: '#1C1B19', edge: 'none', oak: false }
  ];
  function fgTex() {
    var el = document.querySelector('[data-fg-tex]');
    return {
      oak: (el && el.getAttribute('data-oak')) || '',
      strip: (el && el.getAttribute('data-oak-strip')) || ''
    };
  }

  function buildFramingGuideLE() {
    var st = { tab: 0, fin: 0, sizeIdx: 0, menuOpen: false };
    var r1 = function (v) { return Math.round(v * 10) / 10; };

    var modal = Modal(function () {
      var g = FGLE_SIZES[st.sizeIdx];
      var f = FGLE_FINS[st.fin];
      var tex = fgTex();
      var art = fgPrintImg();
      var artNode = art ? '<img src="' + esc(art) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;">' : '';
      var spacer = r1(g.depth === 3 ? 1 : 1.5) + ' cm';

      var tabsHtml = ['Framing', 'Paper'].map(function (label, i) {
        var on = st.tab === i;
        return '<button type="button" data-act="tab" data-i="' + i + '" style="padding:0 2px 14px;background:none;border:none;border-bottom:2px solid ' + (on ? '#111' : 'transparent') + ';margin-bottom:-1px;cursor:pointer;font-size:14px;font-weight:' + (on ? 600 : 400) + ';color:' + (on ? '#111' : '#8A8680') + ';letter-spacing:0.02em;">' + label + '</button>';
      }).join('');

      var finBtns = FGLE_FINS.map(function (fc, i) {
        var on = st.fin === i;
        return '<button type="button" data-act="fin" data-i="' + i + '" style="flex:1 1 0;min-width:0;box-sizing:border-box;height:56px;box-sizing:border-box;display:grid;grid-template-rows:12px auto;align-content:center;justify-items:start;row-gap:6px;padding:10px 14px;overflow:hidden;background:#fff;border:1px solid ' + (on ? '#111' : '#E3E1DD') + ';cursor:pointer;font-size:12px;font-weight:' + (on ? 600 : 400) + ';color:#111;text-align:left;"><span style="display:block;width:52px;max-width:100%;height:11px;background:' + fc.bg + ';box-shadow:inset 0 0 0 1px rgba(17,17,17,0.14);"></span>' + fc.label + '</button>';
      }).join('');
      var sizeMenu = FGLE_SIZES.map(function (s, i) {
        var on = i === st.sizeIdx;
        return '<button type="button" data-act="size" data-i="' + i + '" style="width:100%;display:flex;justify-content:space-between;align-items:center;padding:13px 18px;background:' + (on ? '#F7F6F2' : '#fff') + ';border:none;border-top:' + (i === 0 ? 'none' : '1px solid #ECEAE6') + ';cursor:pointer;"><span style="font-size:14px;font-weight:' + (on ? 600 : 400) + ';color:#111;">' + s.name + '</span><span style="font-size:12px;letter-spacing:0.1em;text-transform:uppercase;color:#8A8680;">' + (s.code || '—') + '</span></button>';
      }).join('');
      var controls = '<div class="fg-guide-controls" style="display:grid;grid-template-columns:1.3fr 1fr;gap:24px;margin-bottom:28px;">'
        + '<div><div style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:#111;margin-bottom:12px;">Finish</div><div style="display:flex;gap:8px;">' + finBtns + '</div>'
        + (st.fin === 0 ? '<div style="font-size:12px;line-height:1.6;color:#8A8680;margin-top:10px;max-width:52ch;">Natural is solid Australian oak — grain and tone vary from batch to batch, so each frame carries its own character and may differ slightly from the one pictured.</div>' : '')
        + '</div>'
        + '<div><div style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:#111;margin-bottom:12px;">Size</div><div style="position:relative;">'
        + '<button type="button" data-act="menu" style="width:100%;box-sizing:border-box;height:56px;display:flex;justify-content:space-between;align-items:center;padding:0 18px;background:#fff;border:1px solid #111;cursor:pointer;"><span style="font-size:14px;font-weight:600;">' + g.name + '</span><span style="font-size:10px;color:#8A8680;">' + (st.menuOpen ? '▲' : '▼') + '</span></button>'
        + '<div style="display:' + (st.menuOpen ? 'block' : 'none') + ';position:absolute;top:calc(100% + 6px);left:0;right:0;background:#fff;border:1px solid #111;box-shadow:0 16px 32px -16px rgba(17,17,17,0.25);z-index:20;max-height:280px;overflow-y:auto;">' + sizeMenu + '</div>'
        + '</div></div></div>';

      // ---- cross-section (26 px/cm) ----
      var facePx = Math.round(g.face * 26), depthPx = Math.round(g.depth * 26);
      var stripBg = f.oak && tex.strip ? 'background-image:url(' + esc(tex.strip) + ');background-size:100% 100%;' : '';
      var crossSection = '<div style="position:relative;background:#F1EFEB;height:340px;overflow:hidden;display:flex;align-items:center;justify-content:center;">'
        + '<div style="width:230px;">'
        + '<div style="display:flex;align-items:flex-end;gap:8px;padding-bottom:6px;padding-left:22px;">'
        + '<div style="flex:0 0 auto;width:' + facePx + 'px;border-bottom:1px solid #A38B5F;height:6px;border-left:1px solid #A38B5F;border-right:1px solid #A38B5F;"></div>'
        + '<div style="font-size:10px;letter-spacing:0.08em;color:#A38B5F;white-space:nowrap;">' + r1(g.face) + ' cm face</div></div>'
        + '<div style="display:flex;">'
        + '<div style="display:flex;flex-direction:column;align-items:center;padding-right:8px;"><div style="flex:1;width:1px;background:#A38B5F;"></div><div style="font-size:10px;letter-spacing:0.08em;color:#A38B5F;writing-mode:vertical-rl;transform:rotate(180deg);padding:4px 0;">' + r1(g.depth) + ' cm deep</div><div style="flex:1;width:1px;background:#A38B5F;"></div></div>'
        + '<div style="flex:1;"><div style="display:flex;height:' + depthPx + 'px;">'
        + '<div style="width:' + facePx + 'px;background:' + f.bg + ';' + stripBg + 'border:' + f.edge + ';"></div>'
        + '<div style="flex:1;display:flex;flex-direction:column;">'
        + '<div style="height:5px;background:#DCE4E6;"></div>'
        + '<div style="height:14px;border-left:6px solid #fff;"></div>'
        + '<div style="height:8px;background:#fff;box-shadow:0 1px 2px rgba(17,17,17,0.18);"></div>'
        + '<div style="height:4px;background:#E7E2D8;"></div>'
        + '<div style="flex:1;"></div>'
        + '<div style="height:8px;background:#CBC5B8;"></div>'
        + '</div></div></div></div>'
        + '<div style="display:grid;grid-template-columns:auto 1fr;gap:4px 10px;padding:16px 0 0 9px;">'
        + '<div style="width:10px;height:10px;background:#DCE4E6;margin-top:2px;"></div><div style="font-size:10.5px;color:#55524D;">2 mm premium acrylic glazing</div>'
        + '<div style="width:10px;height:10px;background:#fff;box-shadow:inset 0 0 0 1px #E1DED8;margin-top:2px;"></div><div style="font-size:10.5px;color:#55524D;">Museum matboard, raised off the print</div>'
        + '<div style="width:10px;height:10px;background:#E7E2D8;margin-top:2px;"></div><div style="font-size:10.5px;color:#55524D;">Your print, dry mounted on acid-free mountboard</div>'
        + '<div style="width:10px;height:10px;background:#CBC5B8;margin-top:2px;"></div><div style="font-size:10.5px;color:#55524D;">Sealed backing</div>'
        + '</div></div>'
        + '<span class="fg-panel-label">Cross-section</span></div>';

      // ---- corner detail (14 px/cm) ----
      var cFace = Math.round(g.face * 14);
      var cMatL = Math.round((g.face + ((g.fw - 2 * g.face) - g.mw) / 2) * 14);
      var cMatT = Math.round((g.face + ((g.fh - 2 * g.face) - g.mh) / 2) * 14);
      var cImgL = Math.round((g.face + ((g.fw - 2 * g.face) - g.mw) / 2 + 1) * 14);
      var cImgT = Math.round((g.face + ((g.fh - 2 * g.face) - g.mh) / 2 + 1) * 14);
      var cornerBg = f.oak && tex.oak ? 'background:' + f.bg + ' url(' + esc(tex.oak) + ');background-size:cover;' : 'background:' + f.bg + ';';
      var corner = '<div style="position:relative;background:#F1EFEB;height:340px;overflow:hidden;">'
        + '<div style="position:absolute;top:42px;left:42px;width:calc(100% + 40px);height:calc(100% + 100px);min-width:400px;min-height:400px;box-shadow:0 18px 40px -20px rgba(17,17,17,0.4);">'
        + '<div style="position:absolute;inset:0;' + cornerBg + 'border:' + f.edge + ';"></div>'
        + '<div style="position:absolute;top:' + cFace + 'px;left:' + cFace + 'px;right:0;bottom:0;background:#fff;box-shadow:inset 2px 2px 6px rgba(17,17,17,0.22);"></div>'
        + '<div style="position:absolute;top:' + cMatT + 'px;left:' + cMatL + 'px;right:0;bottom:0;background:#fff;box-shadow:-1px -1px 0 #E1DED8, inset 2px 2px 4px rgba(17,17,17,0.12);"></div>'
        + '<div style="position:absolute;top:' + cImgT + 'px;left:' + cImgL + 'px;right:0;bottom:0;background:#E7E2D8;overflow:hidden;">' + artNode + '</div>'
        + '</div><span class="fg-panel-label">Corner detail</span></div>';

      // ---- spec tables ----
      function specTable(head, rows) {
        return '<div><div style="font-size:11px;letter-spacing:0.18em;text-transform:uppercase;color:#8A8680;padding-bottom:12px;border-bottom:1px solid #111;">' + head + '</div>'
          + rows.map(function (r) {
              return '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:16px;padding:14px 0;border-bottom:1px solid #ECEAE6;"><div style="font-size:13px;color:#8A8680;">' + r[0] + '</div><div style="font-size:13px;font-weight:600;color:#111;text-align:right;">' + r[1] + '</div></div>';
            }).join('') + '</div>';
      }
      var profileRows = [
        ['Frame depth', r1(g.depth) + ' cm'], ['Moulding face', r1(g.face) + ' cm'],
        ['Approx. framed weight', r1(g.kg) + ' kg'], ['Mount', 'Dry mounted · acid-free mountboard'],
        ['Hanging', 'D-rings or stainless steel wire']
      ];
      var materialRows = [
        ['Glazing', '2 mm premium acrylic'],
        ['Frame', st.fin === 0 ? 'Solid Australian oak' : 'Solid Italian wood, painted'],
        ['Matboard', 'Museum-grade, acid-free'],
        ['Spacer', spacer + ' — lifts glazing off the mat'],
        ['Finishing', 'Taped back · felt pads']
      ];

      // ---- construction strip ----
      function conLayer(inner, label) {
        return '<div style="display:flex;flex-direction:column;align-items:center;gap:12px;width:92px;">' + inner + '<div style="font-size:10.5px;text-align:center;color:#55524D;line-height:1.4;">' + label + '</div></div>';
      }
      var frameLayerStyle = f.oak && tex.oak
        ? 'border:11px solid transparent;border-image:url(' + esc(tex.oak) + ') 39 stretch;'
        : 'border:11px solid ' + f.bg + ';';
      var construction = '<div style="position:relative;background:#F1EFEB;padding:30px 20px 20px;margin-bottom:8px;">'
        + '<div style="display:flex;justify-content:center;align-items:flex-start;gap:16px;flex-wrap:wrap;">'
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);' + frameLayerStyle + 'box-shadow:4px 6px 10px -6px rgba(17,17,17,0.3);"></div>', st.fin === 0 ? 'Australian oak frame' : 'Italian wood frame')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:linear-gradient(135deg,#EDF3F5 0%,#DCE4E6 100%);border:1px solid #C6D2D6;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.25);"></div>', 'Acrylic glazing')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);border:7px solid #fff;box-shadow:0 0 0 1px #E1DED8, inset 0 0 0 1px #E1DED8, 4px 6px 10px -6px rgba(17,17,17,0.22);"></div>', 'Spacer · ' + spacer)
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:#fff;border:1px solid #E1DED8;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.22);display:flex;align-items:center;justify-content:center;"><div style="width:36px;height:52px;background:#F1EFEB;box-shadow:inset 0 0 0 1px #E1DED8;"></div></div>', 'Museum matboard')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:#fff;border:1px solid #E1DED8;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.22);padding:8px 8px 12px;"><div style="width:100%;height:100%;background:#E7E2D8;overflow:hidden;">' + artNode + '</div></div>', 'Your print, dry mounted')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:#EFEAE0;border:1px solid #DDD5C4;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.22);"></div>', 'Acid-free mountboard')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:#EFEAE0;border:1px solid #DDD5C4;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.22);position:relative;"><div style="position:absolute;top:-4px;left:8px;right:8px;height:8px;background:#D8CCB2;"></div><div style="position:absolute;bottom:-4px;left:8px;right:8px;height:8px;background:#D8CCB2;"></div><div style="position:absolute;left:-4px;top:12px;bottom:12px;width:8px;background:#D8CCB2;"></div><div style="position:absolute;right:-4px;top:12px;bottom:12px;width:8px;background:#D8CCB2;"></div></div>', 'Framing tape seal')
        + conLayer('<div style="width:70px;height:92px;transform:skewY(-8deg);background:#EFEAE0;border:1px solid #DDD5C4;box-shadow:4px 6px 10px -6px rgba(17,17,17,0.22);position:relative;"><div style="position:absolute;top:22px;left:12px;width:8px;height:12px;border:1.5px solid #8A8680;border-radius:3px;box-sizing:border-box;"></div><div style="position:absolute;top:22px;right:12px;width:8px;height:12px;border:1.5px solid #8A8680;border-radius:3px;box-sizing:border-box;"></div><div style="position:absolute;top:27px;left:19px;right:19px;height:1.5px;background:#8A8680;"></div></div>', 'D-rings & wire')
        + '</div>'
        + '<div style="position:absolute;left:14px;top:14px;background:#fff;padding:6px 10px;font-size:10px;letter-spacing:0.16em;text-transform:uppercase;color:#8A8680;">Construction</div>'
        + '</div>';

      var framingTab = '<div style="display:' + (st.tab === 0 ? 'block' : 'none') + ';padding-top:26px;">'
        + '<div style="display:flex;align-items:baseline;gap:14px;margin-bottom:10px;flex-wrap:wrap;"><div class="serif" style="font-size:28px;line-height:1;">Premium Shadow Box</div><div style="font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#B0ABA2;">Handcrafted in our exclusive Sydney workshop</div></div>'
        + '<p style="font-size:14px;line-height:1.7;color:#55524D;margin:0 0 28px;max-width:70ch;">Every limited edition print is framed the same way: dry mounted to an acid free backing board, set behind a conservation window mat inside a deep, handmade shadow box — natural Australian oak, or Italian-milled timber in white or black. A spacer holds the paper back from UV-filtering acrylic, with air around it, and the signature border stays visible.</p>'
        + controls
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:36px;">' + crossSection + corner + '</div>'
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:28px 64px;margin-bottom:28px;">' + specTable('Profile · ' + g.name, profileRows) + specTable('Materials', materialRows) + '</div>'
        + '<p style="font-size:13px;line-height:1.7;color:#8A8680;margin:0 0 24px;max-width:68ch;">Every frame is handmade from solid wood, professionally taped at the back with felt pads on the lower corners, and arrives ready to hang. Collector and Statement sizes ship rolled — framing at these scales is arranged locally.</p>'
        + construction
        + '</div>';

      var paperTab = '<div style="display:' + (st.tab === 1 ? 'block' : 'none') + ';padding-top:26px;">'
        + '<div style="display:flex;align-items:baseline;gap:14px;margin-bottom:10px;"><div class="serif" style="font-size:28px;line-height:1;">Smooth Fine Art</div><div style="font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#A38B5F;border:1px solid #E5DCC9;padding:4px 8px;">Ilford</div></div>'
        + '<p style="font-size:14px;line-height:1.7;color:#55524D;margin:0 0 28px;max-width:70ch;">A smooth, acid-free Ilford fine-art stock with a matte surface and gentle warmth. It renders soft tonal transitions beautifully and is built to outlast its owner.</p>'
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:36px;">'
        + '<div style="position:relative;background:#F1EFEB;height:300px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;overflow:hidden;">'
        + '<div class="serif" style="font-size:40px;line-height:1;">200 gsm</div>'
        + '<div style="display:flex;align-items:center;gap:8px;"><div style="width:180px;height:7px;background:#FDFCFA;border:1px solid #E1DED8;box-shadow:0 2px 4px rgba(17,17,17,0.1);"></div><div style="font-size:10px;letter-spacing:0.08em;color:#A38B5F;">0.30 mm</div></div>'
        + '<div style="font-size:12px;letter-spacing:0.08em;color:#8A8680;">Matte · smooth · natural white</div>'
        + '<span class="fg-panel-label">Sheet</span></div>'
        + '<div style="position:relative;height:300px;border:1px solid #ECEAE6;overflow:hidden;"><div style="width:100%;height:100%;background:#E7E2D8;">' + artNode + '</div><span class="fg-panel-label">Print detail</span></div>'
        + '</div>'
        + '<div class="fg-guide-specs" style="display:grid;grid-template-columns:1fr 1fr;gap:28px 64px;margin-bottom:28px;">'
        + specTable('Stock', [['Brand', 'Ilford'], ['Weight', '200 gsm'], ['Thickness', '0.30 mm'], ['Surface', 'Matte · smooth']])
        + specTable('Archival', [['Brightness', 'Natural white'], ['Print method', 'Archival giclée'], ['Printer', 'Canon imagePROGRAF PRO-6100'], ['Inks', 'LUCIA PRO pigment · 12-colour'], ['Rated longevity', '100+ yrs']])
        + '</div>'
        + '<p style="font-size:13px;line-height:1.7;color:#8A8680;margin:0 0 8px;max-width:68ch;">Every print is made on the same archival, acid-free stock — signed and numbered by hand in the signature border.</p>'
        + '</div>';

      return '<div class="fg-head fg-head--tabs"><div class="fg-head-row"><div>'
        + '<div class="eyebrow fg-eyebrow-ico">' + ICON.frame + ' Framing &amp; paper guide</div>'
        + '<h3 class="serif fg-title">How your print is made</h3></div>'
        + '<button type="button" class="fg-close" data-fg-close aria-label="Close">' + ICON.close + '</button></div>'
        + '<div class="fg-tabbar" style="display:flex;gap:28px;border-bottom:1px solid #ECEAE6;margin-top:14px;">' + tabsHtml + '</div></div>'
        + '<div class="fg-body">' + framingTab + paperTab + '</div>'
        + '<div class="fg-footer"><div class="fg-foot-meta"><span>' + (st.tab === 0 ? 'One framing, done properly — depth and face shown update with size.' : 'Every print ships on archival, acid-free stock.') + '</span></div>'
        + '<div style="display:flex;align-items:baseline;gap:16px;"><span style="font-size:13px;color:#111;"><b>' + f.label + '</b> · Premium Shadow Box</span>'
        + '<button type="button" class="fg-cta" data-fg-close>Close</button></div></div>';
    });

    modal._bind = function (panel) {
      if (!panel.__fgleClick) {
        panel.__fgleClick = true;
        panel.addEventListener('click', function (e) {
          var b = e.target.closest && e.target.closest('[data-act]');
          if (!b) { if (st.menuOpen) { st.menuOpen = false; modal.paint(); } return; }
          var act = b.getAttribute('data-act'), i = +b.getAttribute('data-i');
          if (act === 'tab') st.tab = i;
          else if (act === 'fin') st.fin = i;
          else if (act === 'size') { st.sizeIdx = i; st.menuOpen = false; }
          else if (act === 'menu') st.menuOpen = !st.menuOpen;
          else return;
          modal.paint();
        });
      }
    };

    return {
      open: function () {
        var cur = readCurrentSize();
        for (var i = 0; i < FGLE_SIZES.length; i++) {
          if ((FGLE_SIZES[i].code && FGLE_SIZES[i].code === cur.code) || FGLE_SIZES[i].name.toLowerCase() === String(cur.name || '').toLowerCase()) { st.sizeIdx = i; break; }
        }
        st.menuOpen = false;
        modal.open();
      }
    };
  }

  /* --------------------- Framing & Paper Guide ---------------------- */
  var framingGuide;
  function buildFramingGuide() {
    var ALL_SIZES = RECT_SIZES.concat(SQUARE_SIZES);
    var state = { tab: 'framing', prof: 'classic', fin: 'natural', paper: 'cotton', gsize: RECT_SIZES[0].code, idx: 0, panels: [] };
    var modal = Modal(function () {
      var profile = PROFILES.filter(function (p) { return p.id === state.prof; })[0];
      var finish = FINISHES.filter(function (f) { return f.id === state.fin; })[0];
      var paper = PAPERS.filter(function (p) { return p.id === state.paper; })[0];

      // Size-dependent framing detail (driven by the in-guide Size selector).
      var gsizeObj = ALL_SIZES.filter(function (s) { return s.code === state.gsize; })[0] || ALL_SIZES[0];
      var gsizeName = gsizeObj.name;
      var isShadow = state.prof === 'shadow';
      var sd = shadowDims(gsizeName);
      var dpDepth = isShadow ? sd.depth : '2 cm';
      var dpFace = isShadow ? sd.face : '2 cm';
      var glazingStr = acrylicThickness(gsizeName) + ' acrylic' + (isShadow ? ' · with spacer' : '');
      var mountStr = isShadow ? 'Floated on a spacer set behind the acrylic' : 'Flush behind acrylic, on acid-free foamboard';
      var hardware = hangingHardware(gsizeName);
      var diagProfile = { label: profile.label, depth: dpDepth, face: dpFace, depthMm: isShadow ? sd.depthMm : 20, faceMm: isShadow ? sd.faceMm : 20, float: isShadow };

      if (state.tab === 'framing') {
        state.panels = [
          { inner: frameCrossSection(diagProfile, finish), label: 'Cross-section · to scale' },
          { inner: cornerMacro(finish, diagProfile, true), label: finish.label + ' · corner' },
          { inner: photoInner(room(1), 'In a room'), label: 'In a room' }
        ];
      } else {
        state.panels = [
          { inner: paperMacro(paper), label: 'Surface · macro' },
          { inner: paperEdge(paper), label: 'Sheet thickness' },
          { inner: photoInner(PRINT, 'Print detail'), label: 'Print detail' }
        ];
      }

      var chips = (state.tab === 'framing'
        ? PROFILES.map(function (p) { return { id: p.id, label: p.label, note: p.priceNote, on: state.prof === p.id, kind: 'prof' }; })
        : PAPERS.map(function (p) { return { id: p.id, label: p.label, note: p.tag, on: state.paper === p.id, kind: 'paper' }; })
      ).map(function (c) {
        return '<button type="button" class="fg-pill' + (c.on ? ' is-on' : '') + '" data-fg-' + c.kind + '="' + c.id + '">'
          + '<span class="fg-pill__name">' + esc(c.label) + '</span>' + (c.note ? '<span class="fg-pill__dim">' + esc(c.note) + '</span>' : '') + '</button>';
      }).join('');

      var tabsRow = [['framing', 'Framing'], ['paper', 'Paper']].map(function (t) {
        return '<button type="button" class="fg-toptab' + (state.tab === t[0] ? ' is-on' : '') + '" data-fg-tab="' + t[0] + '">' + t[1] + '</button>';
      }).join('');

      // Finish swatches — sit above the panels and drive the corner preview.
      var finishesRow = state.tab !== 'framing' ? '' :
        '<div style="display:flex;align-items:flex-end;gap:20px;flex-wrap:wrap;margin:0 0 22px">'
        + '<span class="eyebrow" style="padding-bottom:8px">Finish</span>'
        + FINISHES.map(function (f) {
            var active = state.fin === f.id;
            var brd = f.id === 'white' ? '1px solid var(--line-strong)' : '1px solid rgba(0,0,0,.14)';
            return '<button type="button" data-fg-fin="' + f.id + '" title="' + esc(f.desc) + '" style="display:flex;flex-direction:column;align-items:center;background:none;border:none;padding:0;cursor:pointer">'
              + '<span style="width:64px;height:36px;border-radius:6px;background:' + f.swatch + ';border:' + brd + ';box-shadow:0 1px 3px rgba(28,27,24,.10)"></span>'
              + '<span style="width:64px;height:2px;margin-top:7px;background:' + (active ? 'var(--ink)' : 'transparent') + '"></span>'
              + '<span style="font-size:13px;margin-top:6px;font-weight:' + (active ? 700 : 500) + ';color:' + (active ? 'var(--ink)' : 'var(--muted)') + '">' + esc(f.label) + '</span>'
              + '</button>';
          }).join('')
        + '</div>';

      var body;
      if (state.tab === 'framing') {
        var gSizeSel = '<label class="fg-select"><span>Size</span><select data-fg-gsize>'
          + ALL_SIZES.map(function (s) { return '<option value="' + esc(s.code) + '"' + (s.code === state.gsize ? ' selected' : '') + '>' + esc(s.name) + ' · ' + esc(s.code) + '</option>'; }).join('')
          + '</select></label>';
        body = '<p class="fg-note">' + esc(profile.desc) + '</p>'
          + '<div class="fg-selects" style="margin-top:18px;max-width:340px">' + gSizeSel + '</div>'
          + '<div class="fg-specs">'
          + '<div><div class="eyebrow fg-spec-head">Profile · ' + esc(gsizeName) + '</div>'
          + specRow('Frame depth', dpDepth, true) + specRow('Moulding face', dpFace) + specRow('Mount', mountStr) + specRow('Hanging', hardware) + '</div>'
          + '<div><div class="eyebrow fg-spec-head">Materials</div>'
          + specRow('Glazing', glazingStr, true) + specRow('Frame', profile.material) + specRow('Finishing', 'Taped back · felt pads') + '</div></div>'
          + '<p class="fg-note" style="margin-top:14px">Every frame is real solid wood, professionally taped at the back with felt pads on the lower corners. Depth, hanging and acrylic shown are for the ' + esc(gsizeName) + ' size.</p>';
      } else {
        body = '<div class="fg-paper-head"><h4 class="serif">' + esc(paper.label) + '</h4><span class="fg-paper-tag">' + esc(paper.tag) + '</span></div>'
          + '<p class="fg-note" style="margin-top:10px">' + esc(paper.desc) + '</p>'
          + '<div class="fg-specs">'
          + '<div><div class="eyebrow fg-spec-head">Stock</div>'
          + specRow('Brand', paper.brand, true) + specRow('Weight', paper.weight) + specRow('Thickness', paper.thick) + specRow('Surface', paper.finish) + '</div>'
          + '<div><div class="eyebrow fg-spec-head">Archival</div>'
          + specRow('Brightness', paper.white, true) + specRow('Optical brighteners', paper.oba) + specRow('Print method', 'Archival giclée') + specRow('Rated longevity', paper.longevity) + '</div></div>';
      }

      var footer = state.tab === 'framing'
        ? '<div class="fg-footer"><div class="fg-foot-meta"><span><b>' + esc(finish.label) + '</b> · ' + esc(profile.label) + '</span></div>'
          + '<button type="button" class="fg-cta" data-fg-apply>Apply this framing</button></div>'
        : '<div class="fg-footer"><div class="fg-foot-meta"><span>Every print ships on archival, acid-free stock.</span></div>'
          + '<button type="button" class="fg-cta" data-fg-close>Got it</button></div>';

      return header('frame', 'Framing & Paper Guide', 'How your print is made', false)
        + '<div class="fg-toptabs">' + tabsRow + '</div></div>'
        + '<div class="fg-body fg-body--tight"><div class="fg-pills fg-pills--chips">' + chips + '</div>'
        + finishesRow
        + imageBlock(state.panels, state.idx) + body + '</div>' + footer;
    });
    modal._bind = function (panel) {
      Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-tab]'), function (b) {
        b.addEventListener('click', function () { state.tab = b.getAttribute('data-fg-tab'); state.idx = 0; modal.paint(); });
      });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-prof]'), function (b) {
        b.addEventListener('click', function () { state.prof = b.getAttribute('data-fg-prof'); state.idx = 0; modal.paint(); });
      });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-paper]'), function (b) {
        b.addEventListener('click', function () { state.paper = b.getAttribute('data-fg-paper'); state.idx = 0; modal.paint(); });
      });
      Array.prototype.forEach.call(panel.querySelectorAll('[data-fg-fin]'), function (b) {
        b.addEventListener('click', function () { state.fin = b.getAttribute('data-fg-fin'); modal.paint(); });
      });
      var gsizeEl = panel.querySelector('[data-fg-gsize]');
      if (gsizeEl) gsizeEl.addEventListener('change', function () { state.gsize = gsizeEl.value; state.idx = 0; modal.paint(); });
      bindSwipe(panel, state, function (i) { state.idx = i; modal.paint(); });
      var apply = panel.querySelector('[data-fg-apply]');
      if (apply) apply.addEventListener('click', function () { applyFraming(state.fin, state.prof); modal.close(); });
    };
    return {
      open: function () {
        var cur = readCurrentFraming();
        var curSize = readCurrentSize();
        state.tab = 'framing'; state.fin = cur.fin; state.prof = cur.prof; state.idx = 0;
        if (ALL_SIZES.filter(function (s) { return s.code === curSize.code; })[0]) state.gsize = curSize.code;
        modal.open();
      }
    };
  }

  /* ----------------------------- wiring ----------------------------- */
  // Close any open guide overlay (used when jumping between the two guides,
  // e.g. the "Framing guide" link inside the Size Guide modal).
  function closeOpenGuides() {
    Array.prototype.forEach.call(document.querySelectorAll('.fg-overlay:not([hidden])'), function (o) {
      o.setAttribute('hidden', '');
    });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var sg = e.target.closest && e.target.closest('[data-fo-size-guide]');
    if (sg) { e.preventDefault(); closeOpenGuides(); if (!sizeGuide) sizeGuide = buildSizeGuide(); sizeGuide.open(); return; }
    var fg = e.target.closest && e.target.closest('[data-fo-framing-guide]');
    if (fg) {
      e.preventDefault(); closeOpenGuides();
      // LE pages get the Premium Shadow Box guide; the default page keeps the
      // legacy Framing & Paper guide (it also sells Classic frames).
      if (document.querySelector('.le-template')) {
        if (!framingGuideLE) framingGuideLE = buildFramingGuideLE();
        framingGuideLE.open();
      } else {
        if (!framingGuide) framingGuide = buildFramingGuide();
        framingGuide.open();
      }
    }
  });
  var framingGuideLE;
})();

